
define("json!strings/en-US.json", function(){ return {
    "admin.nav.architect": "Architect",

    "admin.nav.encryptionKeys": "Encryption Keys",
    "admin.nav.evaluationForms": "Evaluation Forms",
    "admin.nav.surveyForms": "Survey Forms",
    "admin.nav.queues": "Queues",
    "admin.nav.policies": "Policies",
    "admin.nav.scripting": "Scripting",
    "admin.nav.scripting.scripts": "Scripts",
    "admin.nav.scripting.templates": "Templates",

    "advancedUserSelect.cancel": "Cancel",
    "advancedUserSelect.email": "Email",
    "advancedUserSelect.byGroup": "By Group",
    "advancedUserSelect.byRole": "By Role",
    "advancedUserSelect.location": "Location",
    "advancedUserSelect.name": "Name",
    "advancedUserSelect.noResults": "No Results",
    "advancedUserSelect.reportsTo": "Reports To",
    "advancedUserSelect.save": "Save",
    "advancedUserSelect.search": "Search",
    "advancedUserSelect.selected": "Selected",
    "advancedUserSelect.selectedCounts": "{{assignedCount}} people assigned, {{addedCount}} added, {{removedCount}} removed",
    "advancedUserSelect.selectUsers": "Select Users",
    "advancedUserSelect.showSelected": "Show Selected",

    "agentDashboard.statName.date":"Date",
    "agentDashboard.noName": "No Name",

    "agentDetails.month.date": "Date",
    "agentDetails.month.dateFormat": "MMM D",

    "agentSelectorView.placeholderText": "Type or Select an Agent",
    "agentSelectorView.qualityEvaluator.placeholderText": "Type or select a Quality Evaluator",
    "agentSelectorView.qualityAdmin.placeholderText": "Type or select a Quality Admin",
    "agentSelectorView.noItems": "No matching agents",
    "agentSelectorView.noAgentsSelected": "There must be at least 1 selected user.",

    "agentsList.zeroAgents": "Zero agent records were found.",
    "agentsList.agents": "Agents",
    "agentsList.filterLabel": "Filter Agents",
    "agentsList.status": "Status",
    "agentsList.timeInStatus": "Time In Status",
    "agentsList.interactionType.phone": "Phone Interaction",
    "agentsList.error" : "There was an error retrieving the list of agents.",

    "aniSelectorView.enterAni": "Add an ANI to filter",

    "audioPlayerSetup.installWebm": "Install the WebM audio codec for playback in Internet Explorer.",

    "authentication.oauth.error": "No authentication token was found.",

    "columnChart.tooltip.date": "Date:",
    "columnChart.tooltip.value": "Value:",
    "columnChart.axis.label.date": "Date",
    "columnChart.axis.label.interactions": "Interactions",
    "columnChart.axis.label.transfers": "Transfers",

    "lineChart.tooltip.date": "Date:",
    "lineChart.tooltip.value": "Value:",
    "lineChart.tooltip.minutes": "minutes",
    "lineChart.axis.label.minutes": "{{value}} minutes",
    "lineChart.axis.label.seconds": "{{value}} seconds",
    "lineChart.axis.label.time.minutes": "Time",
    "lineChart.axis.label.date": "Date",
    "lineChart.axis.label.percent": "Percentage",
    "lineChart.axis.label.interactions": "Interactions",
    "lineChart.series.label.targetGoal": "Target Service Level %",

    "chatDetails.title": "Chat Log",
    "chatDetails.messages.empty.title": "Empty Chat Recording",
    "chatDetails.messages.empty.body": "There are no messages in this chat.",

    "dashboard.title.agent": "Agent",
    "dashboard.title.contactCenter": "Contact Center",
    "dashboard.title.qualityEvaluator": "Quality Evaluator",
    "dashboard.title.qualityAdmin": "Quality Admin",

    "dataTable.applyFilterButtonTitle": "Apply",
    "dataTable.columnConfiguration.saveButtonTitle": "Apply",
    "dataTable.columnConfiguration.cancelButtonTitle": "Cancel",
    "dataTable.columnConfiguration.visibleColumns": "Visible Columns",
    "dataTable.columnConfiguration.availableColumns": "Available Columns",
    "dataTable.customize": "Customize",
    "dataTable.customizeColumns": "Show / Hide Columns",
    "dataTable.filterChangeTitle": "Your filter has changed",
    "dataTable.resetDefaults": "Reset to Defaults",
    "dataTable.activateSortAscending": "{{columnLabel}}: activate to sort column ascending",
    "dataTable.activateSortDescending": "{{columnLabel}}: activate to sort column descending",
    "dataTable.placeholder.search": "Search",

    "dateRange.facet.display": "{{startDate}} - {{endDate}}",
    "dateRange.facet.default.display": "{{startDate}} - {{endDate}} (Default)",

    "dateRangePicker.today": "Today",
    "dateRangePicker.yesterday": "Yesterday",
    "dateRangePicker.priorWeek": "Prior Week",
    "dateRangePicker.priorMonth": "Prior Month",
    "dateRangePicker.weekToDate": "Week to Date",
    "dateRangePicker.monthToDate": "Month to Date",
    "dateRangePicker.last31": "Last 31 days",
    "dateRangePicker.yearToDate": "Year to Date",
    "dateRangePicker.applyLabel": "Apply",
    "dateRangePicker.cancelLabel": "Cancel",
    "dateRangePicker.fromLabel": "From",
    "dateRangePicker.toLabel": "To",
    "dateRangePicker.weekLabel": "W",
    "dateRangePicker.customRangeLabel": "Custom Range",
    "dateRangePicker.last7": "Last 7 Days",
    "dateRangePicker.last30": "Last 30 Days",
    "dateRangePicker.last90": "Last 90 Days",
    "dateRangePicker.invalidDate": "Invalid date",
    "dateRangePicker.apply": "Apply",
    "dateRangePicker.cancel": "Cancel",
    "dateRangePicker.range.placeholder": "Select Range...",
    "dateRangePicker.yearFormat": "{{year}}",

    "dateRangePicker.range.error.default": "You must specify either custom ranges or default ranges, not both.",
    "dateRangePicker.range.error.overLimit.month" : "The range selected is over 31 days. Please refine your selection.",
    "dateRangePicker.range.error.invalidTime": "The time range you have selected is invalid.",

    "dateRangePicker.tooltips.today": "Go to today",
    "dateRangePicker.tooltips.clear": "Clear selection",
    "dateRangePicker.tooltips.close": "Close the picker",
    "dateRangePicker.tooltips.selectMonth": "Select Month",
    "dateRangePicker.tooltips.prevMonth": "Previous Month",
    "dateRangePicker.tooltips.nextMonth": "Next Month",
    "dateRangePicker.tooltips.selectYear": "Select Year",
    "dateRangePicker.tooltips.prevYear": "Previous Year",
    "dateRangePicker.tooltips.nextYear": "Next Year",
    "dateRangePicker.tooltips.selectDecade": "Select Decade",
    "dateRangePicker.tooltips.prevDecade": "Previous Decade",
    "dateRangePicker.tooltips.nextDecade": "Next Decade",
    "dateRangePicker.tooltips.prevCentury": "Previous Century",
    "dateRangePicker.tooltips.nextCentury": "Next Century",
    "dateRangePicker.tooltips.pickHour": "Pick Hour",
    "dateRangePicker.tooltips.incrementHour": "Increment Hour",
    "dateRangePicker.tooltips.decrementHour": "Decrement Hour",
    "dateRangePicker.tooltips.pickMinute": "Pick Minute",
    "dateRangePicker.tooltips.incrementMinute": "Increment Minute",
    "dateRangePicker.tooltips.decrementMinute": "Decrement Minute",
    "dateRangePicker.tooltips.pickSecond": "Pick Second",
    "dateRangePicker.tooltips.incrementSecond": "Increment Second",
    "dateRangePicker.tooltips.decrementSecond": "Decrement Second",
    "dateRangePicker.tooltips.togglePeriod": "Toggle Period",
    "dateRangePicker.tooltips.selectTime": "Select Time",

    "dateTime.smallDuration": "mm:ss",
    "dateTime.longDurationNoLeadingZero": "h:mm:ss",

    "annotation.bookmarkTitle": "Bookmark",
    "annotation.description": "Description:",
    "annotation.duration": "Duration:",
    "annotation.holdTitle": "Hold",
    "annotation.pauseTitle": "Pause",
    "annotation.securePauseTitle": "Secure Pause",
    "annotation.keywordTitle": "Keyword Spot",

    "annotation.seconds": "seconds",
    "annotation.secondsDescription": "({{seconds}} seconds)",
    "annotation.time": "Time:",
    "annotation.unknownTitle": "Annotation:",
    "annotation.input.placeholder": "Add Annotation",
    "annotation.input.screenReader.label": "Add Annotation",
    "annotation.input.buttonText": "Annotate",

    "header.messages.accessibleCloseButtonLabel": "close alert message",
    "header.logoAltText": "Genesys Cloud",

    "baselist.noSelection": "You must first select a row.",
    "baselist.reallyDeleteOne": "Do you really want to delete {{rowCount}} row?",
    "baselist.reallyDelete": "Do you really want to delete {{rowCount}} rows?",
    "baseList.reallyCancel": "Did you really want to cancel {{rowCount}} software upgrades?",

    "calibration.create.evaluators": "Evaluator(s)",
    "calibration.create.use.as.calibration": "Use as Calibration",
    "calibration.create.scoring.index": "Scoring Index Options",
    "calibration.create.yes": "Yes",
    "calibration.create.no": "No",
    "calibration.create.none": "None",
    "calibration.create.scoring.index.calibrator": "Create Scoring Index",
    "calibration.create.expert": "Expert Evaluator",
    "calibration.create.selectCalibrationEvaluators": "There must be at least one evaluator on the calibration to choose an expert evaluator.",
    "calibration.create.selectEvaluationForm": "There must be an evaluation form selected to create a scoring index.",
    "calibration.createCalibrationRequest.error.default": "The request to create the calibration failed.",
    "calibration.evaluationFormRequest.error.default": "The request to retrieve the evaluation form failed.",
    "calibration.submitValidations.failure.title": "Evaluation Validation Failed",
    "calibration.submitValidations.failure.message": "There are unanswered questions in the scoring index.",

    "calibrationResults.calibrationEvaluators": "Evaluators:",
    "calibrationResults.calibrationExpertEvaluator": "Expert Evaluator:",
    "calibrationResults.deleteCalibration": "Delete",
    "calibrationResults.deleteCalibration.evaluationTooOld": "Calibration can not be deleted because one of its evaluations was created more than 90 days ago",
    "calibrationResults.editCalibration": "Edit Calibration",
    "calibrationResults.evaluationFormName": "Evaluation Form:",
    "calibrationResults.editEvaluators": "Edit",
    "calibrationResults.columnName.questionGroup": "Question Group",
    "calibrationResults.columnName.question": "Question",
    "calibrationResults.columnName.scoringIndex": "Scoring Index",
    "calibrationResults.columnName.expertEvaluator": "{{name}} (Expert)",
    "calibrationResults.rowName.evaluationFormTotal": "Total Score:",
    "calibrationResults.rowName.questionGroupTotal": "Total Score:",
    "calibrationResults.questionGroupTitle": "Question Group:",
    "calibrationResults.getCalibrationRequest.error.default": "The request to get the calibration failed.",
    "calibrationResults.updateCalibrationRequest.error.default": "The request to update the calibration failed.",
    "calibrationResults.highScore": "High Score:",
    "calibrationResults.lowScore": "Low Score:",
    "calibrationResults.averageScore": "Average Score:",
    "calibrationResults.variance": "Variance: ",

    "chat.guest.name": "Guest",
    "chat.agent.name": "Agent",

    "chat.timeFormat": "MMM D, h:MM tt",
    "chat.view.fullName": "{{first}} {{last}}",

    "checkedCell.checked": "Checked",

    "coaching.startDateFormat": "MMMM D, YYYY",

    "composer.apply": "Apply",
    "composer.cancel": "Cancel",
    "composer.no": "No",
    "composer.yes": "Yes",
    "composer.delete.notification.body": "Undo",
    "composer.delete.notification.title": "{{type}} Successfully Deleted",
    "composer.entity.question": "Question",
    "composer.entity.multipleChoiceQuestionAnswer": "Multiple Choice Question Answer",
    "composer.entity.questionGroup": "Question Group",
    "composer.entity.component": "Component",

    "composer.evaluations.moveUp": "Move Up",
    "composer.evaluations.moveDown": "Move Down",
    "composer.evaluations.delete": "Delete",
    "composer.evaluations.favorite": "Toggle Favorite",
    "composer.evaluations.confirmDeleteMultiple": "Are you sure you want to delete these evaluations?",
    "composer.evaluations.confirmDeleteSingle": "Are you sure you want to delete this evaluation?",
    "composer.evaluations.editor.addQuestionGroup": "Add Question Group",
    "composer.evaluations.editor.addQuestionGroupAriaAbove": "Add a question group above the selected question group",
    "composer.evaluations.editor.addQuestionGroupAriaBelow": "Add a question group below the selected question group",
    "composer.evaluations.editor.addQuestion": "Add Question",
    "composer.evaluations.editor.addQuestionType": "Select Question Type To Add:",
    "composer.evaluations.editor.backToList": "Back to list",
    "composer.evaluations.editor.backToListWarning": "Back to list (discard changes)",
    "composer.evaluations.editor.evaluation.defaultName": "[Evaluation name here]",
    "composer.evaluations.editor.evaluation.duplicateNameError.title": "Duplicate Name Error",
    "composer.evaluations.editor.evaluation.duplicateNameError.message": "An evaluation with that name already exists.  Please choose a unique name and try again.",
    "composer.evaluations.editor.evaluation.nameTooLong": "The evaluation name exceeds the limit of 250 characters",
    "composer.evaluations.editor.loadFail.title": "Loading Failed",
    "composer.evaluations.editor.loadFail.message": "The attempt to load the evaluation form has failed. Ensure that it exists and try again.",
    "composer.evaluations.editor.loadFail.forbidden": "Your account does not have permission to access this evaluation. Please contact your security administrator.",
    "composer.evaluations.editor.multipleChoiceQuestion.answer.defaultText": "[Answer text here]",
    "composer.evaluations.editor.multipleChoiceQuestion.answer.valueLabel": "Value:",
    "composer.evaluations.editor.options": "Options",
    "composer.evaluations.editor.preview": "Preview Mode",
    "composer.evaluations.editor.previewToggleOn": "Preview On",
    "composer.evaluations.editor.previewToggleOff": "Preview Off",
    "composer.evaluations.editor.previewSubmit": "Preview Submit Evaluation",
    "composer.evaluations.editor.publish": "Publish",
    "composer.evaluations.editor.published": "This evaluation form has been published",
    "composer.evaluations.editor.publishFail.title": "Publish Failed",
    "composer.evaluations.editor.publishFail.message": "The attempt to publish the evaluation form has failed.",
    "composer.evaluations.editor.publishSuccess.title": "Publish Succeeded",
    "composer.evaluations.editor.publishSuccess.message": "The evaluation form was successfully published.",
    "composer.evaluations.editor.publishing": "Publishing",
    "composer.evaluations.editor.question": "Question",
    "composer.evaluations.editor.multipleChoiceQuestionAnswer": "Multiple Choice Question Answer",
    "composer.evaluations.editor.question.clearResponseLabel": "Clear",
    "composer.evaluations.editor.question.commentsRequiredLabel": "Comments Required",
    "composer.evaluations.editor.question.helpTextLabel": "Help Text",
    "composer.evaluations.editor.question.isNaEnabledLabel": "N/A Enabled Question",
    "composer.evaluations.editor.question.naLabel": "N/A",
    "composer.evaluations.editor.question.showHelpLabel": "help",
    "composer.evaluations.editor.questionGroup": "Question Group",
    "composer.evaluations.editor.questionGroup.defaultAnswersTo": "Answers Default To:",
    "composer.evaluations.editor.questionGroup.defaultAnswersTo.highest": "Highest Scoring",
    "composer.evaluations.editor.questionGroup.defaultAnswersTo.NA": "N/A",
    "composer.evaluations.visibilityOperator.description": "Show this when {{{anyOrAll}}} of the following responses are selected.",
    "composer.evaluations.editor.visibilityCondition.and": "all",
    "composer.evaluations.editor.visibilityCondition.or": "any",
    "composer.evaluations.editor.visibilityCondition.enable": "Display Conditionally",
    "composer.evaluations.editor.save": "Save",
    "composer.evaluations.editor.unsavedConfirmNavigationWithinSite": "You have unsaved changes. Would you like to save them before navigating away from this page?",
    "composer.evaluations.editor.unsavedConfirmNavigationOffsite": "You have unsaved changes. Are you sure you would like to navigate away from this page?",
    "composer.evaluations.editor.saveFail.title": "Save Failed",
    "composer.evaluations.editor.saveFail.message": "The attempt to save the evaluation form has failed.",
    "composer.evaluations.editor.saveSuccess.title": "Save Succeeded",
    "composer.evaluations.editor.saveSuccess.message": "The evaluation form was successfully saved.",
    "composer.evaluations.editor.saving": "Saving",
    "composer.evaluations.editor.moveValidations.dialog.title": "Form Validation Errors",
    "composer.evaluations.editor.moveValidations.dialog.cancel": "Cancel",
    "composer.evaluations.editor.moveUpValidation.question.predicateConflict": "Question {{questionGroupIndex}}.{{questionIndex}} can't be moved up because it has visibility conditions that depend on question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}}.",
    "composer.evaluations.editor.moveUpValidation.questionGroup.predicateConflict": "Question Group {{questionGroupIndex}} can't be moved up because it has visibility conditions that depend on question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}}.",
    "composer.evaluations.editor.moveUpValidation.questionGroupQuestion.predicateConflict": "Question Group {{questionGroupIndex}} can't be moved up because question {{questionGroupIndex}}.{{questionIndex}} has visibility conditions that depend on question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}}.",
    "composer.evaluations.editor.moveDownValidation.question.predicateConflict": "Question {{questionGroupIndex}}.{{questionIndex}} can't be moved down because question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}} has visibility conditions that depend on it.",
    "composer.evaluations.editor.moveDownValidation.questionGroup.predicateConflict": "Question Group {{questionGroupIndex}} can't be moved down because question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}} has visibility conditions that depend on it.",
    "composer.evaluations.editor.moveDownValidation.questionGroupQuestion.predicateConflict": "Question Group {{predicateQuestionGroupIndex}} can't be moved down because question {{questionGroupIndex}}.{{questionIndex}} has visibility conditions that depend on question {{predicateQuestionGroupIndex}}.{{predicateQuestionIndex}}.",
    "composer.evaluations.editor.submitValidations.errors": "There are errors on the evaluation. Please review questions.",
    "composer.evaluations.editor.submitValidations.errors.commentsFieldInvalid": "A comment is required for this question.",
    "composer.evaluations.editor.submitValidations.errors.notAnswered": "This question must be answered.",
    "composer.evaluations.editor.submitValidations.preview.success.title": "Evaluation Validation Succeeded",
    "composer.evaluations.editor.submitValidations.preview.success.message": "The evaluation form was successfully validated.",
    "composer.evaluations.editor.submitValidations.preview.failure.title": "Evaluation Validation Failed",
    "composer.evaluations.editor.submitValidations.preview.failure.message": "The attempt to validate the evaluation form has failed.",
    "composer.evaluations.editor.template.name.placeholder": "Name This Template",
    "composer.evaluations.editor.templateSave.nameLabel": "Save Question As Template",
    "composer.evaluations.editor.templateSave.buttonLabel": "Save",
    "composer.evaluations.editor.templateSave.success.title": "Save Succeeded.",
    "composer.evaluations.editor.templateSave.success.message": "The template was successfully saved as \"{{name}}\"",
    "composer.evaluations.editor.templates.save.failure.title": "Save Template Failed",
    "composer.evaluations.editor.templates.save.failure.message": "The template failed to save.",
    "composer.evaluations.editor.templates.save.failure.message.allWhitespace": "The template failed to save because its name was entirely whitespace.",
    "composer.evaluations.editor.templates.getAll.failure.title": "Retrieval of Templates Failed",
    "composer.evaluations.editor.templates.getAll.failure.message": "The templates failed to load",
    "composer.evaluations.evaluation.commentsWatermark": "[Overall evaluation comments]",
    "composer.evaluations.evaluation.totalWeightLabel": "Total Weight:",
    "composer.evaluations.evaluation.totalWeightValue": "{{weight}} %",
    "composer.evaluations.list.create": "Create",
    "composer.evaluations.list.delete": "Delete",
    "composer.evaluations.list.deleteFail.title": "Delete Failed",
    "composer.evaluations.list.deleteFail.message": "The attempt to delete the evaluation form has failed.",
    "composer.evaluations.list.deleteSuccess.title": "Delete Succeeded",
    "composer.evaluations.list.deleteSuccess.message": "The evaluation form was successfully deleted.",
    "composer.evaluations.list.deleteMultipleSuccess.message": "The evaluation forms were successfully deleted.",
    "composer.evaluations.list.grid.instanceName": "Evaluation Form Name",
    "composer.evaluations.list.grid.lastModified": "Last Modified",
    "composer.evaluations.list.grid.published": "Published Versions",
    "composer.evaluations.list.grid.nameFilterPlaceholder": "Filter by name",
    "composer.evaluations.list.disabled": "Disabled",
    "composer.evaluations.list.published": "Published",
    "composer.evaluations.list.published.all": "{{total}} total published versions",
    "composer.evaluations.list.published.all.singular": "{{total}} total published version",
    "composer.evaluations.list.search": "Search",
    "composer.evaluations.list.refresh": "Refresh",
    "composer.evaluations.scoring.failedKillQuestion": "Failed fatal question",
    "composer.evaluations.scoring.groupScoreTitle": "Weighted Scores",
    "composer.evaluations.scoring.score.label": "Score: ",
    "composer.evaluations.scoring.criticalScore.label": "Critical Score: ",
    "composer.evaluations.scoring.groupScore.scoreValue": "{{score}}/{{maxScore}}",
    "composer.evaluations.scoring.groupScore.criticalValue": "{{critScore}}/{{maxCritScore}}",
    "composer.evaluations.scoring.groupScoreValue": "{{score}}/{{maxScore}}",
    "composer.evaluations.scoring.groupScoreCriticalValue":"({{critScore}}/{{maxCritScore}})",
    "composer.evaluations.scoring.groupScoreNoValue": "-/-",
    "composer.evaluations.scoring.scoreSummaryLabel": " Score: {{score}} % | Critical Score: {{critScore}} %",
    "composer.evaluations.scoring.scoreToggle": "Toggle score",
    "composer.evaluations.question.addAnswer": "Add Answer",
    "composer.evaluations.question.commentsWatermark": "[Additional comments]",
    "composer.evaluations.question.commentsRequiredWatermark": "[Additional comments required]",
    "composer.evaluations.question.criticalQuestion": "Critical Question",
    "composer.evaluations.question.criticalQuestion.help": "A critical question can only have two answers",
    "composer.evaluations.question.defaultText": "[Question text here]",
    "composer.evaluations.question.killQuestion": "Fatal Question",
    "composer.evaluations.question.killQuestion.help": "A fatal question must be critical",
    "composer.evaluations.question.scoreValue": "Value: {{score}}",
    "composer.evaluations.question.criticalValue": "| Critical Value: {{critScore}}",
    "composer.evaluations.questionGroup.applicable": "Applicable",
    "composer.evaluations.questionGroup.defaultName": "[Question group name here]",
    "composer.evaluations.questionGroup.isNaEnabledLabel": "N/A Enabled Question Group",
    "composer.evaluations.questionGroup.notApplicable": "Not Applicable",
    "composer.evaluations.questionGroup.weightLabel": "Weight:",
    "composer.evaluations.questionGroup.weightValuePrefix": "",
    "composer.evaluations.questionGroup.weightValuePostfix": "%",
    "composer.evaluations.questionGroup.properties": "Question Group Properties",
    "composer.evaluations.questionPropertiesHeader": "Question Properties",
    "composer.evaluations.questionType.freeText": "Free Text",
    "composer.evaluations.questionType.multipleChoice": "Multiple Choice",
    "composer.evaluations.questionType.range": "Range",
    "composer.evaluations.questionType.yesNo": "Yes/No",
    "composer.evaluations.questionType.yesNo.no": "No",
    "composer.evaluations.questionType.yesNo.yes": "Yes",
    "composer.evaluations.answerPropertiesHeader": "Answer Properties",
    "composer.evaluations.addPredicate": "Add condition",
    "composer.evaluations.removePredicate": "Remove Condition",
    "composer.evaluations.noQuestionText": "No Text",
    "composer.evaluations.status.commentsRequired": "Comments Required",
    "composer.evaluations.status.critical": "Critical",
    "composer.evaluations.status.kill": "Fatal",

    "composer.surveys.list.deleteFail.message": "The attempt to delete the survey form has failed.",
    "composer.surveys.confirmDeleteMultiple": "Are you sure you want to delete these surveys?",
    "composer.surveys.confirmDeleteSingle": "Are you sure you want to delete this survey?",
    "composer.surveys.editor.survey.defaultName": "[Survey name here]",
    "composer.surveys.editor.previewSubmit": "Preview Submit Survey",
    "composer.surveys.editor.loadFail.message": "The attempt to load the survey form has failed. Ensure that it exists and try again.",
    "composer.surveys.editor.loadFail.title": "Loading Failed",
    "composer.surveys.editor.published": "This survey form has been published",
    "composer.surveys.editor.publishFail.message": "The attempt to publish the survey form has failed.",
    "composer.surveys.editor.publishFail.title": "Publish Failed",
    "composer.surveys.editor.publishSuccess.message": "The survey form was successfully published.",
    "composer.surveys.editor.saveFail.message": "The attempt to save the survey form has failed.",
    "composer.surveys.editor.saveSuccess.message": "The survey form was successfully saved.",
    "composer.surveys.editor.submitValidations.errors": "There are errors on the survey. Please review questions.",
    "composer.surveys.editor.submitValidations.preview.success.message": "The survey form was successfully validated.",
    "composer.surveys.editor.submitValidations.preview.success.title": "Survey Validation Succeeded",
    "composer.surveys.editor.survey.duplicateNameError.message": "A survey with that name already exists.  Please choose a unique name and try again.",
    "composer.surveys.editor.survey.duplicateNameError.title": "Duplicate Name Error",
    "composer.surveys.survey.commentsWatermark": "[Overall survey comments]",
    "composer.surveys.list.deleteMultipleSuccess.message": "The survey forms were successfully deleted.",
    "composer.surveys.list.deleteSuccess.message": "The survey form was successfully deleted.",
    "composer.surveys.list.grid.instanceName": "Survey Form Name",
    "composer.surveys.question.response.tooLong": "Response must be at most {{maxLengthCharacters}} characters in length",
    "composer.surveys.questionType.freeText": "Free Text",
    "composer.surveys.questionType.nps": "NPS",
    "composer.surveys.questionType.readOnly": "Read Only",
    "composer.surveys.scoring.groupScoreTitle": "Question Group Scores",
    "composer.surveys.scoring.scoreSummaryLabel": " Score: {{score}} %",

    "config.addItem": "Add Item",
    "config.backupEdgeGroup": "Backup Edge Group",
    "config.backupDnsServer": "Backup DNS Server",
    "config.cancel": "Cancel",
    "config.save.message": "Your item has been saved.",
    "config.deleteRow.message": "Your item has been deleted.",
    "config.deleteRows.message": "Your items have been deleted.",
    "config.deleteRows.fail.message": "One or more items cannot be deleted.",
    "config.configGroupItems": "Configure Group Items",
    "config.configList.noData": "No matching configs were found.",
    "config.configurations": "Configurations",
    "config.createNewGroup": "Create new configuration group",
    "config.createNewStation": "Create new phone",
    "config.deleteGroup": "Delete Group",
    "config.deleteItem": "Delete Item",
    "config.deleteStation": "Delete Phone",
    "config.description": "Description",
    "config.find": "Find",
    "config.groups": "Groups",
    "config.group.deleteConfirm": "Really delete {{groupName}} ?",
    "config.history": "History",
    "config.ipGateway": "IP Gateway",
    "config.logServer": "Log Server",
    "config.logServerPort": "Log Server Port",
    "config.macAddress": "MAC Address",
    "config.make": "Manufacturer",
    "config.model": "Model",
    "config.name": "Name",
    "config.networkMask": "Subnet Mask",
    "config.noData": "No matching configs were found.",
    "config.noItems": "No items were found.",
    "config.pageStatus": "{{pageNumber}} of {{pageCount}}",

    "config.phoneList.label": "{{label}}",
    "config.primaryEdgeGroup": "Primary Edge Group",
    "config.primaryDnsServer": "Primary DNS Server",
    "config.resource.edges": "Edge",
    "config.resource.phones": "Phone",
    "config.save": "Save",
    "config.schemaList.phones": "Models",
    "config.schemaList.phones.noData": "No matching schemas were found.",
    "config.serial": "Serial Number",
    "config.stationCount": "Using {{current}} of {{max}} phones.",
    "config.station.edit": "Edit",
    "config.sntpServer": "Network Time Server",
    "config.stations": "Phones",
    "config.timezone": "Timezone",
    "config.type": "Type",

    "config.error.400": "Sorry, we're having trouble handling your request. Verify all the information that was entered is correct and try again. If the issue persists, contact support.",
    "config.error.400.DUPLICATE_VALUE.label": "This name has already been used.",
    "config.error.409": "Sorry, this item is currently referenced by 1 or more other items so it cannot be removed at this time. To resolve this issue, remove all dependencies on this item and try again.",
    "config.error.500": "Sorry, we're having trouble handling your request. If the issue persists, contact support.",
    "config.error.generalRateLimit": "Too many requests to the server have been made. Try again in 5 seconds.",
    "config.error.timeout": "The request to the server timed out. Try again in a moment.",
    "config.error.expired": "The previous session has expired. Log in again to continue.",
    "config.error.forbidden": "Your account does not have permission to access this feature. Log in with a different account or contact your security administrator.",

    "audit.action.add": "Added",
    "audit.action.add.document": "Added Document",
    "audit.action.agiAdd": "Added Attribute Group Instance",
    "audit.action.agiAdd.document": "Added Attribute Group Instance to Document",
    "audit.action.agiRemove": "Removed Attribute Group Instance",
    "audit.action.agiRemove.document": "Removed Attribute Group Instance from Document",
    "audit.action.agiUpdate": "Updated Attribute Group Instance",
    "audit.action.agiUpdate.document": "Updated Attribute Group Instance on Document",
    "audit.action.attributeAdd": "Added Attribute",
    "audit.action.attributeAdd.document": "Added Attribute to Document",
    "audit.action.attributeRemove": "Removed Attribute",
    "audit.action.attributeRemove.document": "Removed Attribute from Document",
    "audit.action.attributeUpdate": "Updated Attribute",
    "audit.action.attributeUpdate.document": "Updated Attribute on Document",
    "audit.action.convert": "Converted",
    "audit.action.convert.fax": "Converted Fax",
    "audit.action.copy": "Copied",
    "audit.action.copy.document": "Copied Document",
    "audit.action.create": "Created",
    "audit.action.create.agi": "Created Attribute Group Instance",
    "audit.action.create.attribute": "Created Attribute",
    "audit.action.create.document": "Created Document",
    "audit.action.create.tag": "Created Tag",
    "audit.action.create.workspace": "Created Workspace",
    "audit.action.delete": "Deleted",
    "audit.action.delete.agi": "Deleted Attribute Group Instance",
    "audit.action.delete.attribute": "Deleted Attribute",
    "audit.action.delete.document": "Deleted Document",
    "audit.action.delete.tag": "Deleted Tag",
    "audit.action.delete.workspace": "Deleted Workspace",
    "audit.action.download": "Downloaded",
    "audit.action.download.document": "Downloaded Document",
    "audit.action.fileDelete": "Deleted File",
    "audit.action.fileDelete.document": "Deleted File",
    "audit.action.fileRead": "Retrieved File",
    "audit.action.fileRead.document": "Retrieved File",
    "audit.action.fileSave": "Saved File",
    "audit.action.fileSave.document": "Saved File",
    "audit.action.indexCreate": "Created Index",
    "audit.action.indexCreate.workspace": "Created Workspace Index",
    "audit.action.indexDelete": "Deleted Index",
    "audit.action.indexDelete.agi": "Deleted Attribute Group Instance Index",
    "audit.action.indexDelete.attribute": "Deleted Attribute Index",
    "audit.action.indexDelete.document": "Deleted Document Index",
    "audit.action.indexDelete.tag": "Deleted Tag Index",
    "audit.action.indexDelete.workspace": "Deleted Workspace Index",
    "audit.action.indexSave": "Saved Index",
    "audit.action.indexSave.agi": "Saved Attribute Group Instance Index",
    "audit.action.indexSave.attribute": "Saved Attribute Index",
    "audit.action.indexSave.document": "Saved Document Index",
    "audit.action.indexSave.tag": "Saved Tag Index",
    "audit.action.move": "Moved",
    "audit.action.move.document": "Moved Document",
    "audit.action.receive": "Received",
    "audit.action.receive.fax": "Received Fax",
    "audit.action.remove": "Removed",
    "audit.action.remove.document": "Removed Document",
    "audit.action.shareAdd": "Shared",
    "audit.action.shareRemove": "Unshared",
    "audit.action.shareAdd.document": "Shared Document",
    "audit.action.shareRemove.document": "Unshared Document",
    "audit.action.tagAdd": "Added Tag",
    "audit.action.tagAdd.document": "Added Tags to Document",
    "audit.action.tagRemove": "Removed Tag",
    "audit.action.tagRemove.document": "Removed Tags from Document",
    "audit.action.tagUpdate": "Tag Updated",
    "audit.action.tagUpdate.document": "Updated Tag on Document",
    "audit.action.textExtract": "Extracted Text",
    "audit.action.textExtract.document": "Extracted Text from Document",
    "audit.action.thumbnailCreate": "Created Thumbnail",
    "audit.action.thumbnailCreate.document": "Created Thumbnail for Document",
    "audit.action.update": "Updated",
    "audit.action.update.agi": "Updated Attribute Group Instance",
    "audit.action.update.attribute": "Updated Attribute",
    "audit.action.update.document": "Updated Document",
    "audit.action.update.tag": "Tag Changed in Workspace",
    "audit.action.update.workspace": "Updated Workspace",
    "audit.action.upload": "Uploaded",
    "audit.action.upload.document": "Uploaded Document",
    "audit.action.upload.fax": "Uploaded Fax",
    "audit.action.upload.recording": "Uploaded Recording",
    "audit.action.userAdd": "User Added",
    "audit.action.userAdd.workspace": "User Added to Workspace",
    "audit.action.userRemove": "User Removed",
    "audit.action.userRemove.workspace": "User Removed from Workspace",
    "audit.action.unknown": "Unknown",

    "audit.entity.agi": "Attribute Group Instance",
    "audit.entity.attribute": "Attribute",
    "audit.entity.document": "Document",
    "audit.entity.fax": "Fax",
    "audit.entity.recording": "Recording",
    "audit.entity.tag": "Tag",
    "audit.entity.user": "User",
    "audit.entity.workspace": "Workspace",

    "audit.property.format": "Format",
    "audit.property.id": "Id",
    "audit.property.name": "Name",
    "audit.property.multipleValues": "Multiple Values",
    "audit.property.read": "Read",
    "audit.property.restrictions.decimalPlaces": "Decimal Places",
    "audit.property.restrictions.list": "List",
    "audit.property.restrictions.maximumLength": "Maximum Length",
    "audit.property.restrictions.minimumLength": "Minimum Length",
    "audit.property.restrictions.maximumValue": "Maximum Value",
    "audit.property.restrictions.minimumValue": "Minimum Value",
    "audit.property.restrictions.regularExpression": "Regular Expression",
    "audit.property.restrictions.type": "Type",
    "audit.property.type": "Type",
    "audit.property.workspaceId": "Workspace Id",
    "audit.property.workspaceName": "Workspace Name",

    "contentType.name.acrobat": "PDF",
    "contentType.name.excel": "Excel",
    "contentType.name.richText": "Rich Text",
    "contentType.name.gzip": "GZip Archive",
    "contentType.name.tar": "Tar Archive",
    "contentType.name.zipFile": "Zip Archive",
    "contentType.name.winzip": "WINZIP Archive",
    "contentType.name.archive": "Archive",
    "contentType.name.bitmap": "Bitmap",
    "contentType.name.gif": "GIF",
    "contentType.name.jpeg": "JPEG",
    "contentType.name.svg": "SVG",
    "contentType.name.tif": "TIF",
    "contentType.name.png": "PNG",
    "contentType.name.text": "Text",
    "contentType.name.word": "Word",
    "contentType.name.html": "HTML",
    "contentType.name.css": "CSS",
    "contentType.name.mpeg": "MPEG",
    "contentType.name.audio.mp4" : "Audio MP4",
    "contentType.name.video.mp4" : "Video MP4",
    "contentType.name.audio.webm" : "Audio WebM",
    "contentType.name.video.webm" : "Video WebM",
    "contentType.name.audio.wave" : "Wav",
    "contentType.name.data" : "Data",
    "contentType.name.quicktime": "QuickTime",
    "contentType.name.mp3": "MP3",
    "contentType.name.powerpoint": "PowerPoint",
    "contentType.name.xml": "XML",
    "contentType.name.javascript": "JavaScript",
    "contentType.name.json": "JSON",
    "contentType.name.csv": "CSV",
    "contentType.name.java": "Java",
    "contentType.name.unknown": "Document",
    "contentType.name.userrecording": "Recording",

    "conversationDetails.direction": "Direction",
    "conversationDetails.duration": "Duration",
    "conversationDetails.endTime": "End Time",
    "conversationDetails.externalParticipants": "External Participant(s)",
    "conversationDetails.internalParticipants": "Internal Participant(s)",
    "conversationDetails.interactionType": "Interaction Type",
    "conversationDetails.messageType": "Message Type",
    "conversationDetails.startTime": "Start Time",
    "conversationDetails.conversationDetails": "Interaction",
    "conversationDetails.disconnectReason": "Disconnect Reason",
    "conversationDetails.evaluationsTitle": "Evaluations",
    "conversationDetails.externalContact.nameFormat": "{{{lastName}}}, {{{firstName}}}",
    "conversationDetails.keywordSpots": "Keyphrase Spots",
    "conversationDetails.mediaType": "Recording Type",
    "conversationDetails.metrics": "Interaction Metrics",
    "conversationDetails.monitorTip": "This participant monitored the conversation.",
    "conversationDetails.participantAddress": "Address",
    "conversationDetails.participantAddress.sipDevice": "SIP Device",
    "conversationDetails.participantAddress.copySuccess": "Copied {{text}}",
    "conversationDetails.participantAddress.copy.error.default": "Failed to copy the address to clipboard.",
    "conversationDetails.participantName.unknown": "Unknown",
    "conversationDetails.participantName.system": "System",
    "conversationDetails.participantName.workflow": "Workflow",
    "conversationDetails.participantName.customer": "Customer",
    "conversationDetails.queue": "Queue",
    "conversationDetails.wrapUp": "Wrap-up Information",
    "conversationDetails.awaiting.wrapUp": "Awaiting wrap-up",
    "conversationDetails.unknown.wrapUp.name": "Wrap-up was deleted",
    "conversationDetails.wrapUpCode": "Code",
    "conversationDetails.wrapUpNotes": "Notes",
    "conversationDetails.wrapUpUser": "Name",
    "conversationDetails.pastWrapUps.present": "Additional wrap-up codes were previously used",
    "conversationDetails.pastWrapUps.title": "All wrap-up codes from {{participantName}}",
    "conversationDetails.retention.cancel": "Cancel",
    "conversationDetails.retention.date": "{{date}}",
    "conversationDetails.retention.edit": "(Edit)",
    "conversationDetails.retention.update": "Save",
    "conversationDetails.retention.update.all": "Apply Update to All Recordings",
    "conversationDetails.retention.add": "Add",
    "conversationDetails.retention.no.date": "None",
    "conversationDetails.retention.remove.archive": "Remove archive date",
    "conversationDetails.retention.remove.delete": "Remove delete date",
    "conversationDetails.retention.cannot.filestate": "The recording's current state does not allow for retention updates.",
    "conversationDetails.retention.recordingProtected": "Yes",
    "conversationDetails.retention.recordingProtected.no": "No",

    "conversationDetails.interactionType.call": "Call",
    "conversationDetails.interactionType.chat": "Chat",
    "conversationDetails.interactionType.email": "Email",
    "conversationDetails.interactionType.message": "Message",
    "conversationDetails.interactionType.unknown": "Unknown",
    "conversationDetails.interactionType.callback": "Callback",
    "conversationDetails.interactionType.cobrowse": "Cobrowse",
    "conversationDetails.interactionType.screenshare": "Screen share",

    "conversationDetails.messageType.facebook": "Facebook",
    "conversationDetails.messageType.line": "Line",
    "conversationDetails.messageType.sms": "SMS",
    "conversationDetails.messageType.twitter": "Twitter",
    "conversationDetails.messageType.whatsapp": "WhatsApp",

    "conversationDetails.monitor": "Monitor",
    "conversationDetails.live": "Live",
    "conversationDetails.stopMonitor": "Stop Monitoring",
    "conversationDetails.monitorRequest.error.default": "The request to monitor the participant failed.",
    "conversationDetails.stopMonitorRequest.error.default": "The request to stop monitoring the participant failed.",
    "conversationDetails.tooltip.callMonitor.notPermitted": "You do not have permission to monitor the call.",
    "conversationDetails.updateRetentionDuration.error.default": "The request to update the retention duration(s) has failed.",
    "conversationDetails.getProtectionStatus.error.default": "The request to get the protection status has failed.",
    "conversationDetails.updateProtectionStatus.error.default": "The request to update the protection status has failed.",
    "conversationDetails.retention": "Retention Duration",
    "conversationDetails.recordingInformation": "Recording Information",
    "conversationDetails.recordingInformation.name": "Recording {{recordingNumber}}",
    "conversationDetails.recordingInformation.mediaType.screen": "Screen",
    "conversationDetails.recordingInformation.mediaType.audio": "Call",
    "conversationDetails.recordingInformation.mediaType.chat": "Chat",
    "conversationDetails.recordingInformation.mediaType.email": "Email",
    "conversationDetails.recordingInformation.mediaType.message": "Message",
    "conversationDetails.retentionArchive": "Archive Date",
    "conversationDetails.retentionDelete": "Delete Date",
    "conversationDetails.retentionExported": "Exported Date",
    "conversationDetails.protectedStatus": "Protected",
    "conversationDetails.protectedStatus.toolTip": "Protected from manual or policy-based deletion",
    "conversationDetails.downloadRecording": "Download Recording",
    "conversationDetails.downloadAcdVoicemail": "Download Acd Voicemail",
    "conversationDetails.download.notAuthorized": "You cannot download recordings because you do not have the recording download permission.",
    "conversationDetails.fileName": "File Name:",
    "conversationDetails.fileFormat": "File Format:",
    "conversationDetails.wav": "Wav",
    "conversationDetails.webm": "Webm",
    "conversationDetails.mp3": "Mp3",
    "conversationDetails.cancel": "Cancel",
    "conversationDetails.hide": "Hide",
    "conversationDetails.voicemailInformation.delete": "Delete Now",
    "conversationDetails.voicemailInformation.deleteDate": "Delete Date:",
    "conversationDetails.voicemailInformation.download": "Download",
    "conversationDetails.voicemailInformation.keep": "Keep Indefinitely",
    "conversationDetails.voicemailInformation.name": "ACD Voicemail {{voicemailNumber}}",
    "conversationDetails.voicemailInformation.confirmDelete": "Are you sure you want to permanently delete this voicemail?",

    "conversationDetails.disconnectType.endpoint": "End-User",
    "conversationDetails.disconnectType.client": "Internal-User",
    "conversationDetails.disconnectType.system": "System",
    "conversationDetails.disconnectType.transfer": "Transfer",
    "conversationDetails.disconnectType.error": "Error",
    "conversationDetails.disconnectType.other": "Other",

    "conversationTimeline.header": "Conversation Timeline",
    "conversationTimeline.participantInfo.queueName": "Queue: {{queueName}}",
    "conversationTimeline.participantInfo.noName": "No Name",
    "conversationTimeline.participantInfo.Group": "Group",

    "conversationTimeline.participantPurpose.agent": "Agent",
    "conversationTimeline.participantPurpose.customer": "Customer",
    "conversationTimeline.participantPurpose.external": "External",
    "conversationTimeline.participantPurpose.user": "User",
    "conversationTimeline.participantPurpose.station": "Station",
    "conversationTimeline.participantPurpose.ivr": "IVR",
    "conversationTimeline.participantPurpose.acd": "ACD",
    "conversationTimeline.participantPurpose.api": "API",
    "conversationTimeline.participantPurpose.campaign": "Campaign",
    "conversationTimeline.participantPurpose.group": "Group",
    "conversationTimeline.participantPurpose.dialer.system": "Dialer",
    "conversationTimeline.participantPurpose.voicemail": "Voicemail",
    "conversationTimeline.participantPurpose.fax": "Fax",
    "conversationTimeline.participantPurpose.workflow": "Workflow",
    "conversationTimeline.participantPurpose.unknown": "Unknown",

    "conversationTimeline.segmentType.unknown": "Unknown",
    "conversationTimeline.segmentType.alert": "Alert",
    "conversationTimeline.segmentType.system": "System",
    "conversationTimeline.segmentType.contacting": "Contacting",
    "conversationTimeline.segmentType.delay": "Delay",
    "conversationTimeline.segmentType.dialing": "Dialing",
    "conversationTimeline.segmentType.hold": "Hold",
    "conversationTimeline.segmentType.interact": "Interact",
    "conversationTimeline.segmentType.ivr": "IVR",
    "conversationTimeline.segmentType.scheduled": "Scheduled",
    "conversationTimeline.segmentType.uploading": "Uploading",
    "conversationTimeline.segmentType.voicemail": "Voicemail",
    "conversationTimeline.segmentType.wrapup": "Wrapup",
    "conversationTimeline.segmentType.transmitting": "Transmitting",
    "conversationTimeline.communicationType.voice": "Call",
    "conversationTimeline.communicationType.video": "Video",
    "conversationTimeline.communicationType.chat": "Chat",
    "conversationTimeline.communicationType.email": "Email",
    "conversationTimeline.communicationType.callback": "Callback",
    "conversationTimeline.communicationType.cobrowse": "Cobrowse",
    "conversationTimeline.communicationType.screenshare": "Screen Share",
    "conversationTimeline.communicationType.message": "Message",

    "conversationTimeline.tooltip.startDate": "Start",
    "conversationTimeline.tooltip.endDate": "End",
    "conversationTimeline.tooltip.duration": "Duration",
    "conversationTimeline.tooltip.direction": "Direction",
    "conversationTimeline.tooltip.direction.inbound": "Inbound",
    "conversationTimeline.tooltip.direction.outbound": "Outbound",
    "conversationTimeline.tooltip.disconnectType": "Disconnect Type",
    "conversationTimeline.tooltip.disconnectType.client": "Client",
    "conversationTimeline.tooltip.disconnectType.conferenceTransfer": "Conference Transfer",
    "conversationTimeline.tooltip.disconnectType.consultTransfer": "Consult Transfer",
    "conversationTimeline.tooltip.disconnectType.endpoint": "Endpoint",
    "conversationTimeline.tooltip.disconnectType.error": "Error",
    "conversationTimeline.tooltip.disconnectType.forwardTransfer": "Forward Transfer",
    "conversationTimeline.tooltip.disconnectType.noAnswerTransfer": "No Answer Transfer",
    "conversationTimeline.tooltip.disconnectType.notAvailableTransfer": "Not Available Transfer",
    "conversationTimeline.tooltip.disconnectType.other": "Other",
    "conversationTimeline.tooltip.disconnectType.peer": "Peer",
    "conversationTimeline.tooltip.disconnectType.spam": "Spam",
    "conversationTimeline.tooltip.disconnectType.system": "System",
    "conversationTimeline.tooltip.disconnectType.timeout": "Timeout",
    "conversationTimeline.tooltip.disconnectType.transfer": "Transfer",
    "conversationTimeline.tooltip.disconnectType.transportFailure": "Transport Failure",
    "conversationTimeline.tooltip.messageType": "Message Type",
    "conversationTimeline.tooltip.messageType.facebook": "Facebook",
    "conversationTimeline.tooltip.messageType.line": "Line",
    "conversationTimeline.tooltip.messageType.sms": "SMS",
    "conversationTimeline.tooltip.messageType.twitter": "Twitter",
    "conversationTimeline.tooltip.messageType.whatsapp": "WhatsApp",

    "customerJourneyDetails.navigation.back": "{{backChar}} back to Customer Journeys",
    "customerJourneyDetailsList.participantName": "Participant Name",
    "customerJourneyDetailsList.mediaType": "Media Type",

    "dataGrid.null": "N/A",
    "dataGrid.empty": "No data available.",
    "dataGrid.loading": "Loading...",
    "dataGrid.config": "Customize",
    "dataGrid.pageCount": "of {{pageCount}}",
    "dataGrid.recordCount": "Show",
    "dataGrid.applyFilters": "Apply",
    "dataGrid.filtersChanged": "Your filters have changed.",
    "dataGrid.adjustColumns": "Show/Hide Columns",
    "dataGrid.resetDefaults": "Reset Defaults",
    "dataGrid.cancelFilters": "Cancel",
    "dataGrid.toggleSort": "Toggle Sort",
    "dataGrid.allRowsSelected": "Deselect all rows",
    "dataGrid.noRowsSelected": "Select all rows",
    "dataGrid.partialRowsSelected": "Deselect all rows",
    "dataGrid.selectItem": "Select row",
    "dataGrid.deselectItem": "Deselect row",
    "dataGrid.pinItem": "Pin row",
    "dataGrid.unpinItem": "Unpin row",

    "dialer.dial": "Make Call",
    "dialer.dial.requestError": "The server is having a problem dialing your call. Try again in a moment.",
    "dialer.cancel": "Cancel",
    "dialer.makeCall": "Make Call",
    "dialer.onCall": "On a Call",
    "dialer.recording":"Recording",
    "dialer.placeholder": "Number, name, or queue",
    "dialer.to": "To:",
    "dialer.currentCalls": "Current Calls",
    "dialer.makeACall": "Make a Call",
    "dialer.noCalls": "No Calls",
    "dialer.makeCallForQueue": "Make a call on behalf of a queue",

    "directionsEditorView.noDirectionsSelected": "There must be at least 1 selected direction.",

    "dnisSelectorView.enterDnis": "Add a DNIS to filter",

    "durationFacet.mmss": "{{minutes}}:{{seconds}}",
    "durationFacet.hhmmss": "{{hours}}:{{minutes}}:{{seconds}}",
    "durationFacet.duration.between": "{{startDuration}} to {{endDuration}}",
    "durationFacet.duration.under": "Under {{duration}}",
    "durationFacet.duration.over": "Over {{duration}}",

    "durationPicker.years": "Years",
    "durationPicker.months": "Months",
    "durationPicker.days": "Days",
    "durationPicker.hours": "Hours",
    "durationPicker.minutes": "Minutes",
    "durationPicker.seconds": "Seconds",
    "durationPicker.increment.years": "Increment Years",
    "durationPicker.increment.months": "Increment Months",
    "durationPicker.increment.days": "Increment Days",
    "durationPicker.increment.hours": "Increment Hours",
    "durationPicker.increment.minutes": "Increment Minutes",
    "durationPicker.increment.seconds": "Increment Seconds",
    "durationPicker.decrement.years": "Decrement Years",
    "durationPicker.decrement.months": "Decrement Months",
    "durationPicker.decrement.days": "Decrement Days",
    "durationPicker.decrement.hours": "Decrement Hours",
    "durationPicker.decrement.minutes": "Decrement Minutes",
    "durationPicker.decrement.seconds": "Decrement Seconds",
    "durationPicker.clear": "clear",

    "durationRangePicker.mode.between": "Between",
    "durationRangePicker.mode.over": "Over",
    "durationRangePicker.mode.under": "Under",
    "durationRangePicker.end": "End",
    "durationRangePicker.start": "Start",
    "durationRangePicker.apply": "Apply",

    "percentPicker.low": "Low",
    "percentPicker.high": "High",
    "percentPicker.increment.percent": "Increment Low",
    "percentPicker.decrement.percent": "Increment High",
    "percentPicker.clear": "clear",

    "percentRangePicker.mode.between": "Between",
    "percentRangePicker.mode.over": "Over",
    "percentRangePicker.mode.under": "Under",
    "percentRangePicker.end": "End",
    "percentRangePicker.start": "Start",
    "percentRangePicker.apply": "Apply",

    "evaluationScoreFacet.scoreRange.under": "Under: {{score}}%",
    "evaluationScoreFacet.scoreRange.over": "Over: {{score}}%",
    "evaluationScoreFacet.scoreRange.between": "{{lowScore}}% to {{highScore}}%",

    "evaluationCriticalScoreFacet.scoreRange.under": "Under: {{score}}%",
    "evaluationCriticalScoreFacet.scoreRange.over": "Over: {{score}}%",
    "evaluationCriticalScoreFacet.scoreRange.between": "{{lowScore}}% to {{highScore}}%",

    "numberPicker.low": "Low",
    "numberPicker.high": "High",
    "numberPicker.increment.number": "Increment Low",
    "numberPicker.decrement.number": "Increment High",
    "numberPicker.clear": "Clear",

    "numberRangePicker.mode.between": "Between",
    "numberRangePicker.mode.over": "Over",
    "numberRangePicker.mode.under": "Under",
    "numberRangePicker.apply": "Apply",

    "enabledCell.disabled": "Disabled",
    "enabledCell.enabled": "Enabled",

    "error.timeout": "The request to the server timed out. Try again in a moment.",
    "error.expired": "The previous session has expired. Log in again to continue.",
    "error.forbidden": "Your account does not have permission to access this feature. Log in with a different account or contact your security administrator.",
    "error.generalRateLimit": "Too many requests to the server have been made. Try again in 5 seconds.",

    "error.forbidden.role:agent": "You cannot visit the requested page because you don't have the Agent role. Contact your administrator for access.",
    "error.forbidden.role:supervisor": "You cannot visit the requested page because you don't have the Supervisor role. Contact your administrator for access.",
    "error.forbidden.role:contentManagementUser": "You cannot visit the requested page because you don't have the Content Management role. Contact your administrator for access.",
    "error.forbidden.role:contentManagementAdmin": "You cannot visit the requested page because you don't have the Content Management Admin role. Contact your administrator for access.",
    "error.forbidden.role:telephonyAdmin": "You cannot visit the requested page because you don't have the Telephony Admin role. Contact your administrator for access.",
    "error.forbidden.role:qualityAdmin": "You cannot visit the requested page because you don't have the Quality Admin role. Contact your administrator for access.",
    "error.forbidden.role:qualityEvaluator": "You cannot visit the requested page because you don't have the Quality Evaluator role. Contact your administrator for access.",
    "error.forbidden.role:personnelAdmin": "You cannot visit the requested page because you don't have the Personnel Admin role. Contact your administrator for access.",
    "error.forbidden.role:queueAdmin": "You cannot visit the requested page because you don't have the Queue Admin role. Contact your administrator for access.",
    "error.forbidden.role:scriptDesigner": "You cannot visit the requested page because you don't have the Script Designer role. Contact your administrator for access.",

    "error.default": "An unexpected error occurred, please contact support for assistance.",

    "evaluation.agentName": "Agent Name",
    "evaluation.agentOnEvaluation": "Agent to be Evaluated",
    "evaluation.evaluationAgentReviewed": "Agent Reviewed",
    "evaluation.agentHasRead.yes": "Yes",
    "evaluation.agentHasRead.no": "No",
    "evaluation.queueOnEvaluation": "Queue on evaluation",
    "evaluation.evaluationForm": "Evaluation Form",
    "evaluation.evaluationName": "Evaluation Form Name",
    "evaluation.evaluationReleaseDate": "Release Date/Time",
    "evaluation.evaluationScore": "Score",
    "evaluation.evaluationCriticalScore": "Critical Score",
    "evaluation.evaluationDuration": "Duration",
    "evaluation.externalParticipant": "External Participant",
    "evaluation.evaluationEvaluator": "Evaluator",
    "evaluation.noScore": "No Score",
    "evaluation.noEvaluatorName": "Unknown",
    "evaluation.userOrQueueError.error.default": "There was an unexpected error loading conversation's user(s) and queue(s)",
    "evaluation.evaluatorCantScore": "The selected user does not have permission to score evaluations for this conversation.",
    "evaluation.evaluatorsCantScore": "{{value}} does not have permission to score evaluations for this conversation.",
    "evaluation.agentMissingParticipate": "The agent to be evaluated does not have evaluation participate permission",
    "evaluation.agentIDMissingParticipate": "{{value}} does not have evaluation participate permission",
    "evaluation.createEvaluationRequest.error.default": "The request to create the evaluations failed.",

    "evaluation.noAgentName": "Unknown",
    "evaluation.noQueueName": "Unknown",
    "evaluation.pending": "PENDING",
    "evaluation.inProgress": "IN PROGRESS",
    "evaluation.finished": "COMPLETE",
    "evaluation.partOfCalibration": "Calibration",
    "evaluation.metadata.agentName.label": "Agent Evaluated: ",
    "evaluation.metadata.evaluatorName.label": "Evaluator: ",
    "evaluation.metadata.evaluationAssignedDate.label": "Date of Evaluation: ",
    "evaluation.metadata.releaseDate.label": "Released Date: ",

    "evaluationSummary.formNameTitle": "Form Name",
    "evaluationSummary.dateTitle": "Assigned Date",
    "evaluationSummary.evaluatorTitle": "Evaluator",
    "evaluationSummary.statusTitle": "Status",
    "evaluationSummary.agentHasReadTitle": "Agent Reviewed",
    "evaluationSummary.agentHasRead.yes": "Yes",
    "evaluationSummary.agentHasRead.no": "No",
    "evaluationSummary.deleteEvaluation": "Delete Selected Evaluations",
    "evaluationSummary.addNewEvaluation": "Add New Evaluation",
    "evaluationSummary.pending": "Pending",
    "evaluationSummary.inProgress": "In Progress",
    "evaluationSummary.finished": "Finished",
    "evaluationSummary.displayName.none": "No name found",
    "evaluationSummary.timeRemainingToDelete.days": "{{daysRemaining}} days {{hoursRemaining}} hours",
    "evaluationSummary.timeRemainingToDelete.hours": "{{hoursRemaining}} hours {{minutesRemaining}} mins",
    "evaluationSummary.timeRemainingToDelete.outOfTime": "Too Late",
    "evaluationSummary.timeRemainingToDeleteTitle": "Time Remaining to Delete/Review",
    "evaluationSummary.warning.missingInternalParticipant": "Evaluations Aren't Available For This Interaction",
    "evaluationSummary.warning.missingInternalParticipant.body": "Interactions without internal participants can not be evaluated.",
    "evaluationSummary.warning.evaluation.tooOldToDelete": "Evaluation can not be deleted because it was created more than 90 days ago",
    "evaluationSummary.warning.evaluation.tooOldToScore": "Evaluation can not be scored because it was created more than 45 days ago",
    "evaluationSummary.warning.evaluation.tooOldToReview": "Evaluation can not be reviewed because it was created more than 90 days ago",
    "evaluationSummary.error.delete": "There was an error deleting evaluations",
    "evaluationSummary.error.delete.all": "There was an error deleting the selected evaluations",
    "evaluationSummary.error.delete.body": "{{failedResults}} evaluations failed",

    "evaluatorDashboard.completedInteractions": "Completed Interactions",
    "evaluatorDashboard.completedEvaluations.assignedDateTime": "Assigned Date/Time",
    "evaluatorDashboard.completedEvaluations.releaseDateTime": "Release Date/Time",
    "evaluatorDashboard.completedEvaluations.agent": "Agent",
    "evaluatorDashboard.completedEvaluations.empty": "No completed interactions to display.",
    "evaluatorDashboard.completedEvaluations.formName": "Evaluation Form",
    "evaluatorDashboard.completedEvaluations.isForCalibration": "Calibration",
    "evaluatorDashboard.completedEvaluations.score": "Score",
    "evaluatorDashboard.completedEvaluations.calibration": "Calibration",
    "evaluatorDashboard.loadingEvaluations.error.default": "Unable to load assigned evaluations.",
    "evaluatorDashboard.pendingEvaluations.assignedDateTime": "Assigned Date/Time",
    "evaluatorDashboard.pendingEvaluations.empty": "No pending interactions to display.",
    "evaluatorDashboard.pendingEvaluations.formName": "Evaluation Form",
    "evaluatorDashboard.pendingEvaluations.isForCalibration": "Calibration",
    "evaluatorDashboard.pendingEvaluations.status": "Status",
    "evaluatorDashboard.pendingEvaluations.agent": "Agent",
    "evaluatorDashboard.pendingEvaluations.calibration": "Calibration",
    "evaluatorDashboard.pendingEvaluations.timeRemainingToEvaluate.title": "Time Remaining to Evaluate",
    "evaluatorDashboard.pendingEvaluations.timeRemainingToEvaluate.days": "{{daysRemaining}} days {{hoursRemaining}} hours",
    "evaluatorDashboard.pendingEvaluations.timeRemainingToEvaluate.hours": "{{hoursRemaining}} hours {{minutesRemaining}} minutes",
    "evaluatorDashboard.pendingEvaluations.timeRemainingToEvaluate.outOfTime": "Too Late",
    "evaluatorDashboard.pendingInteractions": "Interactions Needing Attention",
    "evaluatorDashboard.score.unavailable": "-",
    "evaluatorDashboard.status.pending": "Assigned",
    "evaluatorDashboard.status.inprogress": "In Progress",
    "evaluatorDashboard.status.finished": "Finished",
    "evaluatorDashboard.isCalibrationIndicator": "Yes",
    "evaluatorDashboard.isNotCalibrationIndicator": "-",
    "evaluatorDashboard.unauthorized": "You do not have sufficient permissions to see the Quality Evaluator tab.",
    "evaluatorDashboard.queryEvaluations.invalidUser.error.default": "The request to query evaluations failed because the user does not exist in the organization",
    "evaluatorDashboard.banner": "Genesys Cloud will deprecate this page and migrate it to a new location at a later date. Please watch for communication on the Genesys Community regarding these changes",

    "evaluatorSelectorView.searchForEvaluator": "Type or Select an Evaluator",
    "evaluatorSelectorView.noItems": "No matching quality evaluators",
    "evaluatorSelectorView.apply": "Apply",
    "evaluatorSelectorView.cancel": "Cancel",

    "evaluationFormSelector.placeholderText": "Type or Select a Form",
    "evaluationFormSelector.noFormSelected": "There must be at least 1 Form Selected",

    "emailDomainSelector.placeholderText": "Type or Select a Domain",
    "emailDomainSelector.noEmailDomainSelected": "A domain must be selected",
    "emailDomainSelector.domainNotFound": "The selected domain does not exist",
    "emailDomainSelector.aDomainValueIsNotInList": "One of the selected domains does not exist",

    "flowSelector.placeholderText": "Type or Select a Flow",
    "flowSelector.noFlowSelected": "A flow must be selected",

    "surveyFormSelector.placeholderText": "Type or Select a Form",
    "surveyFormSelector.noFormSelected": "There must be at least 1 Form Selected",

    "wrapUpCodeSelector.placeholderText": "Type or Select a Wrap-up Code",
    "wrapUpCodeSelector.noCodeSelected": "There must be at least one wrap-up code selected",

    "evaluation.notification.message.title": "New Evaluation",
    "evaluation.notification.unknownAgent": "Unknown",
    "evaluation.notification.message.body": "",

    "fileSelector.uploaderPlaceholder": "Select File",
    "fileSelector.browse": "Browse",
    "fileSelector.fileReadError": "There was an error in uploading your file",

    "flipswitch.off": "Off",
    "flipswitch.on": "On",
    "flipswitch.toggle": "Toggle",

    "fontNames.arial": "Arial",
    "fontNames.garamond": "Garamond",
    "fontNames.helvetica": "Helvetica",
    "fontNames.timesnewroman": "Times New Roman",

    "borderStyles.solid": "Solid",
    "borderStyles.dotted": "Dotted",
    "borderStyles.dashed": "Dashed",

    "fullcalendar.allDay": "All Day",
    "fullcalendar.today": "Today",
    "fullcalendar.day": "Day",
    "fullcalendar.week": "Week",
    "fullcalendar.month": "Month",
    "fullcalendar.timeFormat": "h(:mm)a",
    "fullcalendar.weekColumnFormat": "ddd M/D",

    "groupSelectorView.placeholderText": "Type or Select a Group",
    "groupSelectorView.noGroupsSelected": "There must be one group selected",

    "inlineDialog.btn.cancel": "Cancel",

    "interactionsList.active": "Active",
    "interactionsList.agentName": "Users",
    "interactionsList.activeAgents": "Active Users",
    "interactionsList.ani": "ANI",
    "interactionsList.historicalConversations": "View Historical Interactions",
    "interactionsList.prevPage": "Previous page",
    "interactionsList.nextPage": "Next page",
    "interactionsList.externalName": "Remote",
    "interactionsList.duration": "Duration",
    "interactionsList.direction": "Direction",
    "interactionsList.direction.inbound": "Inbound",
    "interactionsList.direction.outbound": "Outbound",
    "interactionsList.direction.inboundAndOutbound": "Inbound / Outbound",
    "interactionsList.dnis": "DNIS",
    "interactionsList.getNewConversation": "Get 1 New Interaction",
    "interactionsList.getNewConversations": "Get {{newInteractionCount}} New Interactions",
    "interactionsList.pauseUpdate": "Pause Auto-update",
    "interactionsList.queue": "Queue",
    "interactionsList.wrapUp": "Wrap-Up Code",
    "interactionsList.resumeUpdate": "Resume Auto-update",
    "interactionsList.startDateTime": "Date/Time",
    "interactionsList.timeFormatSeconds": "dddd, LL LTS",
    "interactionsList.conversationSummaryRequest.error.default": "The request for the list of interactions failed.",
    "interactionsList.agentConversationNotifications.error.default": "The request to subscribe to agent conversation notifications failed.",
    "interactionsList.queueConversationNotifications.error.default": "The request to subscribe to queue conversation notifications failed.",

    "intervalTable.error.default": "Failed to load statistical data",

    "historicalAnalyticsView.dateRangeLabel": "Select a date range",
    "historicalAnalyticsView.tableView": "Table View",
    "historicalAnalyticsView.visualizationView": "Chart View",

    "keywordSpotList.agentScore": "Agent Score",
    "keywordSpotList.confidence": "Spotted Confidence",
    "keywordSpotList.customerScore": "Customer Score",
    "keywordSpotList.name": "Name",
    "keywordSpotList.set": "Set",
    "keywordSpotList.time": "Time",
    "keywordSpotList.totalScore": "Total",

    "knockout.validation.required": "This field is required.",
    "knockout.validation.csvListValidation": "The list contains one or more invalid entries.",
    "knockout.validation.csvListValidation.regex.failure": "RegEx Validation Failure",
    "knockout.validation.min": "Enter a value greater than or equal to {{value}}.",
    "knockout.validation.max": "Enter a value less than or equal to {{value}}.",
    "knockout.validation.minLength": "Enter at least {{value}} characters.",
    "knockout.validation.maxLength": "Enter no more than {{value}} characters.",
    "knockout.validation.pattern": "This field is invalid.",
    "knockout.validation.pattern.custom":"The value should match the pattern {{value}}.",
    "knockout.validation.step": "The value must increment by {{value}}.",
    "knockout.validation.email": "This is not a proper email address.",
    "knockout.validation.date": "Enter a proper date.",
    "knockout.validation.dateTimeBeforeOrEqual": "The start cannot come after the end.",
    "knockout.validation.dateISO": "Enter a proper date.",
    "knockout.validation.number": "Enter a number.",
    "knockout.validation.alphabetic": "Enter letters.",
    "knockout.validation.decimal": "Enter a decimal number.",
    "knockout.validation.decimal.length": "Enter a decimal number with {{value}} decimal values.",
    "knockout.validation.integer": "Enter a valid integer.",
    "knockout.validation.digit": "Enter a digit.",
    "knockout.validation.phoneUS": "Specify a valid phone number.",
    "knockout.validation.equal": "Values must equal.",
    "knockout.validation.notEqual": "Values must not equal.",
    "knockout.validation.durationNotEqual": "The start duration cannot be the same as the end duration.",
    "knockout.validation.invalidDuration": "A valid duration must be specified.",
    "knockout.validation.unique": "Make sure the value is unique.",
    "knockout.validation.minItems": "The list must contain at least {{value}} items.",
    "knockout.validation.minItems.singluar": "The list must contain at least {{value}} item.",
    "knockout.validation.maxItems": "The list must contain no more than {{value}} items.",
    "knockout.validation.maxItems.singluar": "The list must contain no more than {{value}} item.",
    "knockout.validation.isLocalTime": "Enter a proper time.",
    "knockout.validation.isLocalTimeBefore": "The start time cannot come after the stop time.",
    "knockout.validation.invalidDurationRange": "The start duration cannot exceed the end duration.",
    "knockout.validation.invalidScoreRange": "The low score cannot be greater than the high score",
    "knockout.validation.invalidOptionalDuration": "The current duration is invalid",
    "knockout.validation.ipv4OrCidr.invalid": "Enter a valid IPv4 or IPv4 CIDR address.",
    "knockout.validation.ipv4.invalid": "Enter a valid IPv4 address.",
    "knockout.validation.ipv4.subnetMask.invalid": "Enter a valid IPv4 subnet mask.",
    "knockout.validation.ipv6.invalid": "Enter a valid IPv6 address.",
    "knockout.validation.ipv6Cidr.invalid": "Enter a valid IPv6 address in CIDR notation.",
    "knockout.validation.ipv4Cidr.invalid": "Enter a valid IPv4 address in CIDR notation.",
    "knockout.validation.isNetworkIPv4.invalid": "Invalid IPv4 network address.",
    "knockout.validation.isNetworkIPv4.validSubnet": "Based on the network mask, network destination should be {{validNetworkIP}}",
    "knockout.validation.isNetworkIPv6.invalid": "Invalid IPv6 network address. Network prefix must be less than 129.",
    "knockout.validation.isNetworkIPv6.validSubnet": "Based on the network mask, network destination should be {{validNetworkIP}}",
    "knockout.validation.isUri":"URI required.",
    "knockout.validation.isTimeIntervalValid.invalid": "Time range is not valid.",
    "knockout.validation.anyConditional.invalid":"This field is invalid.",
    "knockout.validation.isHostName":"Hostname required",

    "listContainerView.cardView": "Card View",
    "listContainerView.currentPageDescription": "{{startAmount}} - {{endAmount}} of {{total}} {{dataName}}",
    "listContainerView.tableView": "Table View",

    "messageDetails.hasArchivedRecordings": "Some parts of this conversation have been archived.",
    "messageDetails.hasDeletedRecordings": "Some parts of this conversation have been deleted.",
    "messageDetails.hasRestoringRecordings": "Some parts of this conversation are being restored from archives. This may take a few hours.",
    "messageDetails.restoreRecordings": "Restore for 30 days",
    "messageDetails.workflowParticipant": "Workflow",
    "messageDetails.apiParticipant": "System",
    "messageDetails.campaignParticipant": "Campaign",

    "mediaTypeEditorView.noMediaTypeSelected": "There must be at least 1 selected media type.",

    "myAccount.cancelLocaleEdit": "Cancel",
    "myAccount.editLocale": "(Edit)",
    "myAccount.locale.en-us": "English (US)",
    "myAccount.locale.es": "Español",
    "myAccount.locale.fr": "Français",
    "myAccount.saveLocale.error.default": "Sorry, we were unable to save your language preferences",
    "myAccount.selectLanguage": "Preferred Language",
    "myAccount.saveLocale": "Save",

    "navMenu.browse": "Browse",
    "navMenu.accountAdmin": "Account Admin",
    "navMenu.qualityAdmin": "Quality Admin",
    "navMenu.orgAdmin": "Organization",

    "nav.config": "Configure",
    "nav.stations": "Telephony",

    "notifications.connectedLiveData": "Connectivity issues have been resolved.",
    "notifications.noLiveData": "{{>div.open}}The connection to real-time data streams has been lost, and we are attempting to reconnect.{{>div.close}}{{>div.open}}You may stop receiving live updates to data, or be unable to chat or set your presence while this issue persists.{{>div.close}}{{>div.open}}Please check your network/internet connection.{{>div.close}}",
    "notifications.dialer.campaignComplete": "The Outbound Dialing Campaign has completed:  {{name}}",
    "notifications.subscribe.error.default":"We are encountering some connectivity issues. You may experience trouble changing your status during this session.",

    "participant.interactionDetails": "Interaction Details",

    "pager.stepper": "Page {{{stepperTemplate}}}",
    "pager.stepper.withPageCount": "Page {{{stepperTemplate}}} of {{{pageCount}}}",
    "pager.size": "{{{pageSizeTemplate}}} records per page",
    "pager.sizePicker.label": "Select number of records per page",

    "playback.archive.restoreRequest.error.default": "The request to update the recording restore length failed.",
    "playback.archive.restoreRequest.400": "The attempted restore operation failed.",
    "playback.archivePeriods.cancel": "Cancel Restoration",
    "playback.archivePeriods.1day": "Keep for a day",
    "playback.archivePeriods.7days": "Keep for 7 days",
    "playback.archivePeriods.30days": "Keep for 30 days",
    "playback.archivePeriods.placeholder": "Restore Recording",
    "playback.archivePeriods.expiresPlaceholder": "Keeping for {{daysLeft}} day(s)",
    "playback.conversationDetails": "Interaction Details",
    "playback.noConversation": "No interaction to display.",
    "playback.noRecording": "There is no recording for this interaction.",
    "playback.callTerminated": "This conversation has ended.",
    "playback.calibrationsRequest.error.default": "The request to get the calibrations failed.",
    "playback.conversationRequest.error.default": "The request to get the interaction failed.",
    "playback.evaluationsRequest.error.default": "The request to get the evaluations failed.",
    "playback.evaluationSummaryRequest.error.default": "The request to get the evaluation summary failed",
    "playback.surveySummaryRequest.error.default": "The request to get the survey summary failed",
    "playback.recordingRequest.error.default": "The request to get the interaction recording failed.",
    "playback.acdVoicemailRequest.error.default": "The request to get the acd voicemail recording failed.",
    "playback.acdVoicemailDelete.error.default": "The request to delete the acd voicemail recording failed.",
    "playback.acdVoicemailKeep.error.default": "The request to set acd voicemail retention policy to indefinite.",
    "playback.recordingPlayback.error.title": "Playback Error",
    "playback.recordingPlayback.error.msg": "An error was encountered during playback, recording is being reloaded.",
    "playback.recordingAnnotation.error.default": "The request to annotate the recording failed.",
    "playback.recordingNotifications.error.default": "The request to subscribe to recording notifications failed.",
    "playback.downloadRecording.error.default" : "The request to download recording failed.",
    "playback.evaluationAnswerEvaluatorSubmitRequest.error.default": "The request to submit the evaluation answers failed.",
    "playback.evaluationAnswerEvaluatorSaveRequest.error.default": "The request to save the evaluation answers failed.",
    "playback.evaluationAnswerAgentSaveRequest.error.default": "The request to save the agent response failed.",
    "playback.externalParticipant": "External Participant",
    "playback.internalParticipant": "Internal Participant",
    "playback.multipleParticipants": "Multiple",
    "playback.participants": "Participants",
    "playback.noParticipants": "No Participants",
    "playback.recordingIsArchived.no.perm.description" : "This recording has been archived. Restoring this recording may take several hours. Contact an administrator with proper permission to restore a recording.",
    "playback.recordingIsArchived.description": "This recording has been archived. Restoring this recording may take several hours. You will be notified once it is available, and it will be available for playback or download from this page.  Your organization can restore {{orgRestoresRemaining}} more archives.",
    "playback.recordingIsArchived.description.noRestoresAvailable": "This recording has been archived however your organization has reached it's maximum number of restorations.  Please try again later.",
    "playback.recordingIsArchived.title": "This Recording Has Been Archived",
    "playback.email.archived.title": "This Email Has Been Archived",
    "playback.email.deleted.title": "This Email Has Been Deleted",
    "playback.screenRecording.title": "Screen Recording Playback",
    "playback.screenRecording.body": "Viewing screen recordings for this interaction requires opening a new window. Click the button below to begin viewing the screen recording.",
    "playback.screenRecording.open": "View Screen Recordings",
    "playback.recordingIsDeleted.title": "No Recording",
    "playback.recordingIsDeleted.description": "This recording has either been deleted or does not exist.",
    "playback.voicemailIsDeleted.title": "No Voicemail Recording",
    "playback.voicemailIsDeleted.description": "This voicemail recording has either been deleted or does not exist.",
    "playback.recordingIsRestoring.description": "Restoring the recording may take several hours. You will be notified once it is available, and it will be available for playback or download from this page.",
    "playback.recordingIsRestoring.title": "This Recording Is Being Restored",
    "playback.recordingIsUploading.description": "This recording is currently uploading. It should be available within 5 minutes.",
    "playback.recordingIsUploading.title": "This Recording Is Currently Uploading",
    "playback.recordingIsLive.title": "This is a Live Conversation",
    "playback.recordingIsLive.description": "This conversation is currently in progress. ",
    "playback.needsWrapup.title": "Currently Waiting for Wrap Up",
    "playback.needsWrapup.description": "Currently waiting for all after call work to be completed.",
    "playback.recording.missingMedia.title": "No Available Media",
    "playback.recording.missingMedia.description": "The selected recording has no media available for playback.",
    "playback.scheduleCoaching": "Schedule Coaching",
    "playback.coaching.appointmentCreatedToast.title": "Scheduled coaching",
    "playback.coaching.appointmentCreatedToast.body": "Coaching session has been scheduled for {{attendee}} on {{startDate}} at {{startTime}} - {{endTime}}.",
    "playback.coaching.appointmentClashToast.title": "Schedule clash",
    "playback.coaching.appointmentClashToast.body": "Could not schedule coaching session as there is a time clash.",
    "playback.evaluation.notification.agent.save.title": "Evaluation Acknowledged",
    "playback.evaluation.notification.agent.save.msg": "Evaluation acknowledged",
    "playback.evaluation.notification.evaluator.save.title": "Evaluation Saved",
    "playback.evaluation.notification.evaluator.save.msg": "Evaluation saved",
    "playback.evaluation.notification.evaluator.submit.title": "Evaluation Submitted",
    "playback.evaluation.notification.evaluator.submitAgentEval.msg": "Evaluation submitted with a release date of {{releaseDate}}",
    "playback.evaluation.notification.evaluator.submitNoRelease.msg": "Evaluation submitted with no release date.",
    "playback.evaluation.notification.evaluator.submitCalibrationEval.msg": "Evaluation submitted for a calibration",
    "playback.evaluation.agentCommentsWatermark": "[Agent comments]",
    "playback.evaluation.never": "Never",
    "playback.evaluation.agentConfirmationLabel": "I have reviewed this evaluation",
    "playback.evaluation.agentReviewedLabel": "The agent has reviewed this evaluation",
    "playback.evaluation.prerelease.label": "Evaluation will release on {{releaseDate}}",
    "playback.evaluation.postrelease.label": "Evaluation was released on {{releaseDate}}",
    "playback.evaluation.norelease.label": "Evaluation will not be released",
    "playback.evaluation.release.label": "Release the evaluation",
    "playback.evaluation.release.now.item": "Immediately",
    "playback.evaluation.release.never": "Never",
    "playback.evaluation.release.endOfDay.item": "At the end of the day",
    "playback.evaluation.release.endOfWeek.item": "At the end of the week",
    "playback.evaluation.release.unchanged.item": "At the existing release time",
    "playback.evaluation.release.custom.item": "Custom",
    "playback.evaluation.release.timezone.required": "Please select a timezone",
    "playback.evaluation.reviewmode.admin": "You are the agent on this evaluation, but you are viewing it as a supervisor.",
    "playback.evaluation.reviewmode.agent": "You are viewing this evaluation as the agent on the evaluation.",
    "playback.evaluation.reviewmode.toggleAdmin": "View the evaluation as a supervisor.",
    "playback.evaluation.reviewmode.toggleAgent": "View the evaluation as an agent.",
    "playback.evaluation.evaluator": "Evaluator",
    "playback.evaluation.print": "Print Evaluation",
    "playback.evaluation.agentSignature": "Agent Signature: ",
    "playback.calibrationSummary.fail.msg": "There was a problem loading the calibration",
    "playback.calibrationSummary.score.na": "N/A",
    "playback.retention.updated": "Retention Data Saved",

    "playback.nav.calibration": "Calibration Results",
    "playback.nav.calibration.deleted.title": "Calibration deleted",
    "playback.nav.calibration.deleted.msg": "Calibration was deleted",
    "playback.nav.calibration.not.deleted.title": "Calibration not deleted",
    "playback.nav.calibration.not.deleted.msg": "Calibration was not deleted due to error",
    "playback.nav.conversationDetails": "Details",
    "playback.nav.evaluation": "Evaluation",
    "playback.nav.qualitySummary": "Quality Summary",
    "playback.nav.journeys": "Customer Journeys",
    "playback.nav.evaluation.submit": "Submit",
    "playback.nav.evaluation.save": "Save",
    "playback.nav.evaluation.cancel": "Cancel",
    "playback.nav.evaluation.delete": "Delete",
    "playback.nav.evaluation.rescore": "Re-Score",
    "playback.nav.newEvaluation": "New Evaluation",
    "playback.nav.evaluation.created": "Evaluation Created",
    "playback.nav.evaluation.created.for": "Evaluation created for {{evaluatorName}}",
    "playback.nav.evaluation.new.missing.agent": "Evaluation cannot be created due to missing agent",
    "playback.nav.evaluation.deleted.title": "Evaluation deleted",
    "playback.nav.evaluation.deleted.msg": "Evaluation was deleted",
    "playback.nav.evaluation.not.deleted.title": "Evaluation not deleted",
    "playback.nav.evaluation.not.deleted.msg": "Evaluation was not deleted due to error",
    "playback.nav.evaluation.useAsScoringIndex.label": " Use as Scoring Index for Calibration",
    "playback.nav.evaluation.createCalibration": "Create Calibration",
    "playback.nav.audit": "Audit Trail",
    "playback.nav.timeline": "Timeline",
    "playback.nav.survey": "Survey",

    "playback.controls.playbackRate": "Speed: x{{speed}}",

    "playback.volume.up": "Volume up",
    "playback.volume.down": "Volume down",
    "playback.volume.muted": "Volume muted",
    "playback.volume.notmuted": "Volume not muted",
    "playback.item.audio.volume.preference": "Audio Preference",
    "playback.next.text": "Next Recording",
    "playback.previous.text": "Previous Recording",

    "playback.email.view.autoGenerated": "[Automatic Reply]",
    "playback.email.view.to": "To",
    "playback.email.view.emailTitle": "{{name}} {{email}}",
    "playback.email.view.subject": "Subject",
    "playback.email.view.from": "From",
    "playback.email.view.attachment": "Attachments",
    "playback.email.view.toggle.html": "Toggle HTML",
    "playback.email.view.unnamed": "unnamed",

    "policies.policiesRequest.error.default": "The request to get the list of policies failed.",

    "policyResource.assignSurvey.inviteInterval.maxTotalTimeDays": "The interval length exceeds the maximum of {{value.maxDays}} days.",

    "policyEditor.actions" : "Actions to Perform",
    "policyEditor.appliesTo": "For Users",
    "policyEditor.cancel": "Cancel",
    "policyEditor.conditions" : "Matching Criteria",
    "policyEditor.duplicatePolicyName": "The policy name must be unique.",
    "policyEditor.getRequest": "The request to get the policy failed.",
    "policyEditor.goBackLinkText": "Policies",
    "policyEditor.newPolicy": "New Policy",
    "policyEditor.policyDescription": "Description",
    "policyEditor.policyDescriptionPlaceholder": "Type a policy description",
    "policyEditor.policyName": "Policy Name",
    "policyEditor.policyNamePlaceholder": "Type a policy name",
    "policyEditor.save": "Save",
    "policyEditor.saveRequest.error.default": "The request to save the policy failed.",
    "policyEditor.criteriaRequired": "One or more criteria must be specified.",
    "policyEditor.listQueue.error": "The request to get the list of queues failed.",

    "policiesMain.create": "Create New Policy",
    "policiesMain.delete": "Delete Selected Policies",
    "policiesMain.details": "Details",
    "policiesMain.enabled": "Enabled",
    "policiesMain.newPolicy": "New Policy",
    "policiesMain.policyDescription": "Description",
    "policiesMain.policyName": "Policy Name",
    "policiesMain.title": "Policies",

    "policiesMain.nav.recordingRetention": "Recording Retention",
    "policiesMain.nav.recordingSecurity": "Recording Security",

    "popover.close": "Close Popover",

    "presenceDefinition.error": "Unable to load presence definitions for your organization.",

    "qualityAdminDashboard.evaluators": "Evaluation Activity",
    "qualityAdminDashboard.evaluators.evaluatorName": "Evaluator Name",
    "qualityAdminDashboard.evaluators.evaluatorGroup": "Evaluator Group",
    "qualityAdminDashboard.evaluators.agentTeam": "Agent Work Team",
    "qualityAdminDashboard.evaluators.search.too.many.results": "Too many results. Please enter more characters",
    "qualityAdminDashboard.evaluators.evaluationProgress": "Evaluations Performed",
    "qualityAdminDashboard.evaluators.evaluationRatio": "{{numEvaluationsCompleted}} / {{numEvaluationsAssigned}}",
    "qualityAdminDashboard.evaluators.calibrationsCompleted": "Calibrations Performed",
    "qualityAdminDashboard.calibrations": "Calibration Activity",
    "qualityAdminDashboard.calibrations.createdDate": "Created Date",
    "qualityAdminDashboard.calibrations.evaluationFormName": "Form Name",
    "qualityAdminDashboard.calibrations.evalCount": "Evaluations",
    "qualityAdminDashboard.calibrations.openCount": "Unfinished",
    "qualityAdminDashboard.calibrations.averageScore": "Average Score",
    "qualityAdminDashboard.calibrations.highScore": "High Score",
    "qualityAdminDashboard.calibrations.lowScore": "Low Score",
    "qualityAdminDashboard.calibrations.scoreVariation": "Score Variation",
    "qualityAdminDashboard.calibrations.unknownEvalForm": "Unknown",
    "qualityAdminDashboard.agentActivity": "Agent Activity",
    "qualityAdminDashboard.agentActivity.placeholderText": "Search For Agent",
    "qualityAdminDashboard.agentActivity.agent": "Agent",
    "qualityAdminDashboard.agentActivity.group": "Group",
    "qualityAdminDashboard.agentActivity.team": "Work Team",
    "qualityAdminDashboard.agentActivity.numOfEvaluations": "# of Evaluations",
    "qualityAdminDashboard.agentActivity.evaluationsExcluded": "{{numEvaluationsExcluded}} evaluations excluded from lack of permission",
    "qualityAdminDashboard.agentActivity.averageScore": "Average Score",
    "qualityAdminDashboard.agentActivity.error": "There was an error loading agent activity",
    "qualityAdminDashboard.unauthorized": "You do not have sufficient permissions to see the Quality Admin tab",

    "qualityManagementService.conversationDirections.inbound": "Inbound",
    "qualityManagementService.conversationDirections.outbound": "Outbound",
    "qualityManagementService.mediaTypes.call": "Call",
    "qualityManagementService.mediaTypes.chat": "Chat",

    "qualitySummary.evaluations": "Evaluations",
    "qualitySummary.surveys": "Completed Surveys",

    "queueSelectorView.searchForQueue": "Search for queue",

    "recordings.notification.message.title": "Recording Restored",
    "recordings.notification.message.body": "View the recording",
    "recordings.transcodeInProgress.text": "Transcoding is still in progress...",

    "scheduledCallbacks.actions": "Actions",
    "scheduledCallbacks.actions.cancel": "Cancel Callback",
    "scheduledCallbacks.actions.cancel.succeeded": "Successfully cancelled the callback",
    "scheduledCallbacks.actions.cancel.requestFailed": "The request to cancel the callback failed",
    "scheduledCallbacks.actions.cancel.failed": "Failed to cancel the callback",
    "scheduledCallbacks.actions.cancel.validateFailed": "Failed to verify if the callback was cancelled",
    "scheduledCallbacks.callbackUserName": "Name",
    "scheduledCallbacks.callbackNumbers": "Callback Numbers",
    "scheduledCallbacks.callbackScheduledTime": "Scheduled Time",
    "scheduledCallbacks.divisions": "Divisions",
    "scheduledCallbacks.divisionNames": "{{{ firstDivision }}}{{#divisions}}, {{{ . }}}{{/divisions}}",
    "scheduledCallbacks.filterByCampaign": "Filter by campaign...",
    "scheduledCallbacks.filterByDivision": "Filter by division...",
    "scheduledCallbacks.filterByQueue": "Filter by queue...",
    "scheduledCallbacks.formattedCallbackNumbers": "{{{ firstNumber }}}{{#numbers}}, {{{ . }}}{{/numbers}}",
    "scheduledCallbacks.campaignName": "Campaign",
    "scheduledCallbacks.queueName": "Queue",

    "schemaForm.listRowLabel": "{{listLabel}} #{{index}}",
    "schemaForm.show": "More Settings",
    "schemaForm.hide": "Less Settings",

    "schemaFormView.general" :"General",
    "schemaFormView.toggle": "Toggle",
    "schemaFormView.emptyList": "The list contains no items.",
    "schemaFormView.validationError": "One or more fields contain errors.",

    "siteMap.home": "Home",
    "siteMap.agents": "Agents",
    "siteMap.alerts": "Alerts",
    "siteMap.alertsInbox": "Inbox",
    "siteMap.alertRules" : "Rules",
    "siteMap.editAlertRule" : "Edit Alert Rule",
    "siteMap.copyAlertRule" : "Copy Alert Rule",
    "siteMap.createAlertRule" : "New Alert Rule",
    "siteMap.agentDetails": "{{pageTitle}}",
    "siteMap.dashboard": "Dashboard",
    "siteMap.agentDashboard": "Dashboard",
    "siteMap.defaultTitle": "Genesys Cloud",
    "siteMap.defaultTitleSeparator": " | ",
    "siteMap.encryptionKeys": "Encryption Keys",
    "siteMap.interactionsList": "Interactions",
    "siteMap.interactionDetails": "Interaction",
    "siteMap.login": "Genesys Cloud Log in",
    "siteMap.myAccount": "My Account",
    "siteMap.policiesList": "Policies",
    "siteMap.queues": "Queues",
    "siteMap.queuesAdmin": "Queues Admin",
    "siteMap.queueDetails": "{{pageTitle}}",
    "siteMap.scheduledCallbacks": "Scheduled Callbacks",
    "siteMap.updatePolicy": "{{pageTitle}}",

    "quality.siteMap.evaluationForms": "Evaluation Forms",
    "quality.siteMap.evaluationFormEditor": "Evaluation Form Editor",
    "quality.siteMap.surveyForms": "Survey Forms",
    "quality.siteMap.surveyFormEditor": "Survey Form Editor",
    "quality.error.generic": "A problem occurred",

    "siteMap.scripts": "Scripts",
    "siteMap.scriptEditor": "Script Editor",
    "siteMap.createScript": "New Script",
    "siteMap.scriptTemplates": "Script Templates",

    "siteMap.settings": "Settings",

    "siteMap.search": "Search",
    "siteMap.admin": "Admin",
    "siteMap.voicemailPolicy": "Voicemail Policy",
    "siteMap.support": "Feedback & Support",

    "statName.acw": "ACW",
    "statName.aht": "AHT",
    "statName.answered": "Answered",
    "statName.avgAcw": "Avg ACW",
    "statName.avgHold": "Avg Hold",
    "statName.avgTalk": "Avg Talk",
    "statName.callsAnswered": "Calls Answered",
    "statName.callsTransferred": "Calls Transferred",
    "statName.customers": "Customers",
    "statName.occupancy": "Occupancy",
    "statName.heldCalls": "Held Calls",
    "statName.heldInteractions": "Held Interactions",
    "statName.loggedIn": "Logged In",
    "statName.talk": "Talk",
    "statName.totalAht": "Total Handle",
    "statName.totalHold": "Hold",
    "statName.transferred": "Transferred",
    "statName.wait": "Wait",

    "statValue.minutesSeconds": "{{minutes}}m {{seconds}}s",
    "statValue.hoursMinutesSeconds": "{{hours}}h {{minutes}}m {{seconds}}s",

    "supervisorDashboard.deprecated": "This view is deprecated in favor of the customizable <i>Dashboards</i> views, located under the Performance menu.",

    "supervisorDashboard.avgSpeedAnswer.title": "Interval ASA",
    "supervisorDashboard.abandonRate.title": "Interval Abandon %",
    "supervisorDashboard.serviceLevelDeviation.title": "Interval Service Level % Deviation",
    "supervisorDashboard.queues": "Queues",
    "supervisorDashboard.avgSpeedAnswer.xAxisTitle": "ASA (sec)",
    "supervisorDashboard.callsAbandonedRate.title": "Abandon %",
    "supervisorDashboard.callsAbandonedRate.xAxisTitle": "Abandon %",
    "supervisorDashboard.customersInteracting.title": "Customers Interacting",
    "supervisorDashboard.serviceLevel.xAxisTitle": "Service Level %",
    "supervisorDashboard.customersWaiting.title": "Customers Waiting",
    "supervisorDashboard.customersWaiting.customerCount": "Interactions Count",
    "supervisorDashboard.mediaTypes.call": "Media Type: Voice",
    "supervisorDashboard.mediaTypes.chat": "Media Type: Chat",
    "supervisorDashboard.pendingEvaluations.title": "Evaluations",
    "supervisorDashboard.serviceLevelTrend.key.met": "Met",
    "supervisorDashboard.serviceLevelTrend.key.missed": "Missed",
    "supervisorDashboard.serviceLevelTrend.xAxisTitle": "Time (Interval)",
    "supervisorDashboard.serviceLevelTrend.title": "Service Level % Trend",
    "supervisorDashboard.dataGrid.tooltip.noData": "No data to display",

    "mediaTypes.voice": "Voice",
    "mediaTypes.chat": "Chat",
    "mediaTypes.email": "Email",
    "mediaTypes.callback": "Callback",
    "mediaTypes.message": "Message",

    "search.none": "None",
    "search.multipleAgents": "{{agentCount}} Users",
    "search.noName": "No Name Found",
    "search.filters.agentsDisplay": "{{{agentNamesDisplay}}}",
    "search.filters.wrapUpCodeDisplay": "{{{wrapUpCodeDisplay}}}",
    "search.filters.filtersSelected" : "{{numberSelected}} selected ",
    "search.filters.filtersSelected.singular" : "{{numberSelected}} selected",
    "search.filters.tooltipSelected": "Selected: ",
    "search.filters.tooltip.unknown": "Unknown",
    "search.filters.queuesDisplay": "{{{queuesDisplay}}}",
    "search.filters.evaluationFormsDisplay": "{{{formsDisplay}}}",
    "search.filters.removeAttrib": "Remove",
    "search.paging.recordsPerPage": "records per page",
    "search.tabs.completedInteractionsTab": "Completed Interactions",
    "search.tabs.restoredInteractionsTab": "Restored Interactions",
    "search.pager.nextPage": "Next Page",
    "search.pager.previousPage": "Previous Page",

    "searchFacet.filterTitle.selection": "Your Selections: ",
    "searchFacet.heading.dateRange": "Date",
    "searchFacet.heading.dnis": "DNIS",
    "searchFacet.heading.duration": "Duration",
    "searchFacet.heading.direction": "Direction",
    "searchFacet.heading.agent": "User",
    "searchFacet.heading.ani": "ANI",
    "searchFacet.heading.evaluationForm": "Evaluation Form",
    "searchFacet.heading.evaluatedAgent": "Evaluated Agent",
    "searchFacet.heading.evaluator": "Evaluator",
    "searchFacet.heading.wrapupCode": "Wrap-up Code",
    "searchFacet.heading.evaluationScore": "Evaluation Score",
    "searchFacet.heading.evaluationCriticalScore": "Evaluation Critical Score",
    "searchFacet.heading.mediaType": "Media Type",
    "searchFacet.filterTitle.dateRange": "Dates:",
    "searchFacet.filterTitle.direction": "Direction:",
    "searchFacet.filterTitle.dnis": "DNIS(s):",
    "searchFacet.filterTitle.duration": "Duration:",
    "searchFacet.filterTitle.agent": "Users:",
    "searchFacet.filterTitle.ani": "ANI(s):",
    "searchFacet.filterTitle.qualityEvaluationForm": "Evaluation Forms:",
    "searchFacet.filterTitle.qualityEvaluationAgent": "Evaluated Agents:",
    "searchFacet.filterTitle.qualityEvaluator": "Evaluators:",
    "searchFacet.filterTitle.queue": "Queues:",
    "searchFacet.filterTitle.freeText": "Search:",
    "searchFacet.filterTitle.wrapUpCode": "Wrap-up Codes:",
    "searchFacet.filterTitle.evaluationScore": "Score:",
    "searchFacet.filterTitle.evaluationCriticalScore": "Critical Score:",
    "searchFacet.filterTitle.mediaType": "Media Type:",
    "searchFacet.filterTitle.text": "Text:",
    "searchFacet.heading.queues": "Queue",
    "searchFacet.customRange": "Custom",
    "searchFacet.customDateRange": "Custom Date Range",
    "searchFacet.pickAgent": "Select User(s)",
    "searchFacet.pickEvaluationForm": "Select Evaluation Form(s)",
    "searchFacet.pickEvaluatedAgent": "Select Evaluated Agent(s)",
    "searchFacet.pickEvaluator": "Select Evaluator(s)",
    "searchFacet.pickQueue": "Select Queue(s)",
    "searchFacet.pickWrapupCode": "Select Wrap-up Code(s)",
    "searchFacet.agentFilterTitle": "User",
    "searchFacet.more": "+ More",
    "searchFacet.duration.0to60": "Under 1 Min",
    "searchFacet.duration.1to5": "1 to 5 Mins",
    "searchFacet.duration.5to10": "5 to 10 Mins",
    "searchFacet.duration.10to20": "10 to 20 Mins",
    "searchFacet.duration.20plus": "Over 20 Mins",
    "searchFacet.evaluationScore.25orLess": "25% or less",
    "searchFacet.evaluationScore.26to50": "25% to 50%",
    "searchFacet.evaluationScore.51to75": "50% to 75%",
    "searchFacet.evaluationScore.76to100": "75% to 100%",
    "searchFacet.evaluationScore.100orMore": "Greater than 100",
    "searchFacet.applyBtn": "Apply",
    "searchFacet.to": " to ",
    "searchFacet.wrapUpCode.placeholderText": "Type or Select a Wrap-up Code",
    "searchFacet.wrapUpCode.apply": "Apply",
    "searchFacet.direction.inbound": "Inbound",
    "searchFacet.direction.outbound": "Outbound",
    "searchFacet.mediaType.call": "Call",
    "searchFacet.mediaType.callback": "Callback",
    "searchFacet.mediaType.chat": "Chat",
    "searchFacet.mediaType.email": "Email",

    "queuesSelect.heading": "Which queues are you working today?",
    "queuesSelect.submit": "Submit",
    "queuesSelect.cancel": "Cancel",
    "queuesSelect.filter.placeholder": "Search",
    "queuesSelect.retrieveQueues.error.default": "There was an error retriving list of available queues.",
    "queuesSelect.joinQueues.error.default": "There was an error completing your request.",
    "queuesSelect.joinQueues.success.title": "Update Queues",
    "queuesSelect.joinQueues.success.body": "You have been activated/deactivated on the requested queues.",
    "queuesSelect.joinQueues.noChange.body": "No changes were made to current queues.",
    "queuesSelect.currentHeader": "Active Queues",
    "queuesSelect.availableHeader": "Available Queues",

    "transferBox.count": "{{{count}}} Selected",
    "transferBox.count.singular": "{{{count}}} Selected",
    "transferBox.remove": "Remove Item",
    "transferBox.add": "Add Item",
    "transferBox.filterPlaceholder": "Filter Items",
    "transferBox.defaultAvailableHeader": "Available Items",
    "transferBox.defaultCurrentHeader": "Selected Items",
    "transferBox.increment": "Move Up",
    "transferBox.decrement": "Move Down",

    "supervisor.nav.agents":    "Agents",
    "supervisor.nav.alerts":    "Alerts",
    "supervisor.nav.alerts.inbox" : "Inbox",
    "supervisor.nav.alerts.rules" : "Rules",
    "supervisor.nav.dashboard": "Dashboard",
    "supervisor.nav.overview": "Overview (Evaluations)",
    "supervisor.nav.interactions": "Interactions",
    "supervisor.nav.queues":    "Queues",
    "supervisor.nav.scheduledCallbacks": "Scheduled Callbacks",

    "surveySummary.formNameTitle": "Form Name",
    "surveySummary.npsScore": "NPS",
    "surveySummary.scoreTitle": "Score",
    "surveySummary.statusTitle": "Status",
    "surveySummary.pending": "Pending",
    "surveySummary.sent": "Sent",
    "surveySummary.inProgress": "In Progress",
    "surveySummary.finished": "Finished",
    "surveySummary.error": "Error",
    "surveySummary.optOut": "Opt Out",
    "surveySummary.expired": "Expired",

    "userCell.noUser" : "N/A",

    "userStatus.available": "Available",
    "userStatus.away": "Away",
    "userStatus.break": "Break",
    "userStatus.busy": "Busy",
    "userStatus.idle": "Idle (Away)",
    "userStatus.meal": "Meal",
    "userStatus.meeting": "Meeting",
    "userStatus.offline": "Offline",
    "userStatus.onQueue": "On Queue",
    "userStatus.training": "Training",
    "userStatus.interacting": "Interacting",
    "userStatus.communicating": "Communicating",
    "userStatus.notResponding": "Not Responding",
    "userStatus.offQueue": "Off Queue",
    "userStatus.outOfOffice": "Out of Office",
    "userStatus.unknown": "Unknown",

    "status.labelTime": "{{status}} / {{time}}",

    "tooltip.close.button" : "Close tooltip",

    "schedule.title": "Organization Schedules",
    "schedule.name": "Schedule Name",
    "schedule.create": "Create New",
    "schedule.delete": "Delete",
    "schedule.createNewSchedule": "Create New Schedule",
    "schedule.update": "Update Schedule",
    "schedule.type": "Recurrence Type",
    "schedule.type.once": "One Time",
    "schedule.type.daily": "Daily",
    "schedule.type.weekly": "Weekly",
    "schedule.type.monthly": "Monthly",
    "schedule.type.yearly": "Yearly",
    "schedule.priority": "Priority",
    "schedule.priority.emergency": "Emergency",
    "schedule.priority.holiday": "Holiday",
    "schedule.priority.nonbusinesshours": "Non-Business Hours",
    "schedule.priority.businesshours": "Business Hours",
    "schedule.start": "Start",
    "schedule.end": "End",
    "schedule.allday": "All Day",
    "schedule.daysOfTheWeek": "Days of the Week",
    "schedule.daysOfTheMonth": "Days of the Month",
    "schedule.onThe": "On the",
    "schedule.on": "On",
    "schedule.relative.first": "First",
    "schedule.relative.second": "Second",
    "schedule.relative.third": "Third",
    "schedule.relative.fourth": "Fourth",
    "schedule.relative.last": "Last",
    "schedule.relative.day": "Day",
    "schedule.relative.in": "in",
    "schedule.save": "Save Schedule",
    "schedule.cancel": "Cancel",
    "schedule.state.active": "Active",
    "schedule.state.inactive": "Inactive",

    "surveySummaryView.bounced": "The survey email invite bounced.",
    "surveySummaryView.complaint": "A complaint was reported from the destination email provider for the survey email invite.",
    "surveySummaryView.unspecifiedError": "The survey invite flow failed on step {{lastActionId}}",

    "statblock.intervals.day": "Day",
    "statblock.intervals.interval": "Interval",
    "statblock.intervals.intervalDate": "{{startTime}} - {{endTime}}",
    "statblock.title": "Real Time Stats by {{{selectedIntervalTemplate}}}",
    "statblock.refresh": "Refresh",
    "statblock.settings": "Settings",

    "inline.confirmation.btn.label.ok":"Ok",
    "inline.confirmation.btn.label.cancel":"Cancel",

    "chatlist.titlelist": "Instant Messages",
    "chatlist.title": "Instant Message",
    "chatlist.empty": "No Instant Messages",
    "chatlist.submit": "Send",
    "chatlist.confirm": "Are you sure you want to end your conversation?",
    "chatlist.me": "Me",

    "directory.toggle": "Toggle Call Options",
    "directory.transfer": "Transfer",
    "directory.chat": "Instant Message",
    "directory.call": "Call",
    "directory.preferred": "Preferred",
    "directory.home": "Home",
    "directory.work": "Work",
    "directory.cell": "Cell",
    "directory.error.home": "{{name}} does not have a home number on record.",
    "directory.error.work": "{{name}} does not have a work number on record.",
    "directory.error.cell": "{{name}} does not have a cell number on record.",
    "directory.error.preferred": "{{name}} does not have a preferred number on record.",
    "directory.confirm.call": "Do you really want to call {{name}} at {{number}}?",
    "directory.header.homePage.title": "Contacts",
    "directory.header.directoryPage.title": "Directory",
    "directory.header.recentPage.title": "Recents",
    "directory.header.favoritesPage.title": "Favorites",
    "directory.header.profilePage.title": "Person",
    "directory.header.searchResultPage.title": "Search",
    "directory.header.button.back": "Back",
    "directory.header.button.home": "Home",

    "phone.queue": "Queue",
    "phone.monitorCall.error.generic": "Failed to monitor the call.",
    "phone.monitorCall.error.conversation.error.monitor.own.conversation": "You cannot monitor a conversation on which you are already a participant.",

    "queueSelectorView.placeholderText": "Type or Select a Queue",
    "queueSelectorView.noItems": "No matching queues",
    "queueSelectorView.noQueuesSelected": "There must be at least 1 selected queue.",

    "userLanguageEditor.save": "Save Languages",
    "userLanguageEditor.error": "Could not save languages. The user may not have sufficient permissions. Contact support.",

    "teamSelectorView.placeholderText": "Type or Select a Work Team",
    "teamSelectorView.noItems": "No matching work teams",
    "teamSelectorView.noTeamsSelected": "There must be at least 1 selected work team.",

    "timeDuration.minutesSecondsMilliseconds": "m:ss.SSS",
    "timeDuration.minutesSeconds": "m:ss",
    "timeDuration.hoursMinutesSeconds": "H:mm:ss",
    "timeDuration.hoursMinutesLocal": "hh:mm A",
    "timeDuration.day": "{{duration}} day",
    "timeDuration.days": "{{duration}} days",
    "timeDuration.year": "{{duration}} year",
    "timeDuration.years": "{{duration}} years",

    "timeZone.Africa/Abidjan": "Africa/Abidjan",
    "timeZone.Africa/Accra": "Africa/Accra",
    "timeZone.Africa/Addis_Ababa": "Africa/Addis_Ababa",
    "timeZone.Africa/Algiers": "Africa/Algiers",
    "timeZone.Africa/Asmara": "Africa/Asmara",
    "timeZone.Africa/Bamako": "Africa/Bamako",
    "timeZone.Africa/Bangui": "Africa/Bangui",
    "timeZone.Africa/Banjul": "Africa/Banjul",
    "timeZone.Africa/Bissau": "Africa/Bissau",
    "timeZone.Africa/Blantyre": "Africa/Blantyre",
    "timeZone.Africa/Brazzaville": "Africa/Brazzaville",
    "timeZone.Africa/Bujumbura": "Africa/Bujumbura",
    "timeZone.Africa/Cairo": "Africa/Cairo",
    "timeZone.Africa/Casablanca": "Africa/Casablanca",
    "timeZone.Africa/Ceuta": "Africa/Ceuta",
    "timeZone.Africa/Conakry": "Africa/Conakry",
    "timeZone.Africa/Dakar": "Africa/Dakar",
    "timeZone.Africa/Dar_es_Salaam": "Africa/Dar_es_Salaam",
    "timeZone.Africa/Djibouti": "Africa/Djibouti",
    "timeZone.Africa/Douala": "Africa/Douala",
    "timeZone.Africa/El_Aaiun": "Africa/El_Aaiun",
    "timeZone.Africa/Freetown": "Africa/Freetown",
    "timeZone.Africa/Gaborone": "Africa/Gaborone",
    "timeZone.Africa/Harare": "Africa/Harare",
    "timeZone.Africa/Johannesburg": "Africa/Johannesburg",
    "timeZone.Africa/Juba": "Africa/Juba",
    "timeZone.Africa/Kampala": "Africa/Kampala",
    "timeZone.Africa/Khartoum": "Africa/Khartoum",
    "timeZone.Africa/Kigali": "Africa/Kigali",
    "timeZone.Africa/Kinshasa": "Africa/Kinshasa",
    "timeZone.Africa/Lagos": "Africa/Lagos",
    "timeZone.Africa/Libreville": "Africa/Libreville",
    "timeZone.Africa/Lome": "Africa/Lome",
    "timeZone.Africa/Luanda": "Africa/Luanda",
    "timeZone.Africa/Lubumbashi": "Africa/Lubumbashi",
    "timeZone.Africa/Lusaka": "Africa/Lusaka",
    "timeZone.Africa/Malabo": "Africa/Malabo",
    "timeZone.Africa/Maputo": "Africa/Maputo",
    "timeZone.Africa/Maseru": "Africa/Maseru",
    "timeZone.Africa/Mbabane": "Africa/Mbabane",
    "timeZone.Africa/Mogadishu": "Africa/Mogadishu",
    "timeZone.Africa/Monrovia": "Africa/Monrovia",
    "timeZone.Africa/Nairobi": "Africa/Nairobi",
    "timeZone.Africa/Ndjamena": "Africa/Ndjamena",
    "timeZone.Africa/Niamey": "Africa/Niamey",
    "timeZone.Africa/Nouakchott": "Africa/Nouakchott",
    "timeZone.Africa/Ouagadougou": "Africa/Ouagadougou",
    "timeZone.Africa/Porto-Novo": "Africa/Porto-Novo",
    "timeZone.Africa/Sao_Tome": "Africa/Sao_Tome",
    "timeZone.Africa/Tripoli": "Africa/Tripoli",
    "timeZone.Africa/Tunis": "Africa/Tunis",
    "timeZone.Africa/Windhoek": "Africa/Windhoek",
    "timeZone.America/Adak": "America/Adak",
    "timeZone.America/Anchorage": "America/Anchorage",
    "timeZone.America/Anguilla": "America/Anguilla",
    "timeZone.America/Antigua": "America/Antigua",
    "timeZone.America/Araguaina": "America/Araguaina",
    "timeZone.America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "timeZone.America/Argentina/Catamarca": "America/Argentina/Catamarca",
    "timeZone.America/Argentina/Cordoba": "America/Argentina/Cordoba",
    "timeZone.America/Argentina/Jujuy": "America/Argentina/Jujuy",
    "timeZone.America/Argentina/La_Rioja": "America/Argentina/La_Rioja",
    "timeZone.America/Argentina/Mendoza": "America/Argentina/Mendoza",
    "timeZone.America/Argentina/Rio_Gallegos": "America/Argentina/Rio_Gallegos",
    "timeZone.America/Argentina/Salta": "America/Argentina/Salta",
    "timeZone.America/Argentina/San_Juan": "America/Argentina/San_Juan",
    "timeZone.America/Argentina/San_Luis": "America/Argentina/San_Luis",
    "timeZone.America/Argentina/Tucuman": "America/Argentina/Tucuman",
    "timeZone.America/Argentina/Ushuaia": "America/Argentina/Ushuaia",
    "timeZone.America/Aruba": "America/Aruba",
    "timeZone.America/Asuncion": "America/Asuncion",
    "timeZone.America/Atikokan": "America/Atikokan",
    "timeZone.America/Bahia_Banderas": "America/Bahia_Banderas",
    "timeZone.America/Bahia": "America/Bahia",
    "timeZone.America/Barbados": "America/Barbados",
    "timeZone.America/Belem": "America/Belem",
    "timeZone.America/Belize": "America/Belize",
    "timeZone.America/Blanc-Sablon": "America/Blanc-Sablon",
    "timeZone.America/Boa_Vista": "America/Boa_Vista",
    "timeZone.America/Bogota": "America/Bogota",
    "timeZone.America/Boise": "America/Boise",
    "timeZone.America/Buenos_Aires": "America/Buenos_Aires",
    "timeZone.America/Cambridge_Bay": "America/Cambridge_Bay",
    "timeZone.America/Campo_Grande": "America/Campo_Grande",
    "timeZone.America/Cancun": "America/Cancun",
    "timeZone.America/Caracas": "America/Caracas",
    "timeZone.America/Cayenne": "America/Cayenne",
    "timeZone.America/Cayman": "America/Cayman",
    "timeZone.America/Chicago": "America/Chicago",
    "timeZone.America/Chihuahua": "America/Chihuahua",
    "timeZone.America/Ciudad_Juarez": "America/Ciudad_Juarez",
    "timeZone.America/Costa_Rica": "America/Costa_Rica",
    "timeZone.America/Creston": "America/Creston",
    "timeZone.America/Cuiaba": "America/Cuiaba",
    "timeZone.America/Curacao": "America/Curacao",
    "timeZone.America/Danmarkshavn": "America/Danmarkshavn",
    "timeZone.America/Dawson_Creek": "America/Dawson_Creek",
    "timeZone.America/Dawson": "America/Dawson",
    "timeZone.America/Denver": "America/Denver",
    "timeZone.America/Detroit": "America/Detroit",
    "timeZone.America/Dominica": "America/Dominica",
    "timeZone.America/Edmonton": "America/Edmonton",
    "timeZone.America/Eirunepe": "America/Eirunepe",
    "timeZone.America/El_Salvador": "America/El_Salvador",
    "timeZone.America/Fort_Nelson": "America/Fort_Nelson",
    "timeZone.America/Fortaleza": "America/Fortaleza",
    "timeZone.America/Glace_Bay": "America/Glace_Bay",
    "timeZone.America/Godthab": "America/Godthab",
    "timeZone.America/Goose_Bay": "America/Goose_Bay",
    "timeZone.America/Grand_Turk": "America/Grand_Turk",
    "timeZone.America/Grenada": "America/Grenada",
    "timeZone.America/Guadeloupe": "America/Guadeloupe",
    "timeZone.America/Guatemala": "America/Guatemala",
    "timeZone.America/Guayaquil": "America/Guayaquil",
    "timeZone.America/Guyana": "America/Guyana",
    "timeZone.America/Halifax": "America/Halifax",
    "timeZone.America/Havana": "America/Havana",
    "timeZone.America/Hermosillo": "America/Hermosillo",
    "timeZone.America/Indiana/Indianapolis": "America/Indiana/Indianapolis",
    "timeZone.America/Indiana/Knox": "America/Indiana/Knox",
    "timeZone.America/Indiana/Marengo": "America/Indiana/Marengo",
    "timeZone.America/Indiana/Petersburg": "America/Indiana/Petersburg",
    "timeZone.America/Indiana/Tell_City": "America/Indiana/Tell_City",
    "timeZone.America/Indiana/Vevay": "America/Indiana/Vevay",
    "timeZone.America/Indiana/Vincennes": "America/Indiana/Vincennes",
    "timeZone.America/Indiana/Winamac": "America/Indiana/Winamac",
    "timeZone.America/Indianapolis": "America/Indianapolis",
    "timeZone.America/Inuvik": "America/Inuvik",
    "timeZone.America/Iqaluit": "America/Iqaluit",
    "timeZone.America/Jamaica": "America/Jamaica",
    "timeZone.America/Juneau": "America/Juneau",
    "timeZone.America/Kentucky/Louisville": "America/Kentucky/Louisville",
    "timeZone.America/Kentucky/Monticello": "America/Kentucky/Monticello",
    "timeZone.America/Kralendijk": "America/Kralendijk",
    "timeZone.America/La_Paz": "America/La_Paz",
    "timeZone.America/Lima": "America/Lima",
    "timeZone.America/Los_Angeles": "America/Los_Angeles",
    "timeZone.America/Lower_Princes": "America/Lower_Princes",
    "timeZone.America/Maceio": "America/Maceio",
    "timeZone.America/Managua": "America/Managua",
    "timeZone.America/Manaus": "America/Manaus",
    "timeZone.America/Marigot": "America/Marigot",
    "timeZone.America/Martinique": "America/Martinique",
    "timeZone.America/Matamoros": "America/Matamoros",
    "timeZone.America/Mazatlan": "America/Mazatlan",
    "timeZone.America/Menominee": "America/Menominee",
    "timeZone.America/Merida": "America/Merida",
    "timeZone.America/Metlakatla": "America/Metlakatla",
    "timeZone.America/Mexico_City": "America/Mexico_City",
    "timeZone.America/Miquelon": "America/Miquelon",
    "timeZone.America/Moncton": "America/Moncton",
    "timeZone.America/Monterrey": "America/Monterrey",
    "timeZone.America/Montevideo": "America/Montevideo",
    "timeZone.America/Montreal": "America/Montreal",
    "timeZone.America/Montserrat": "America/Montserrat",
    "timeZone.America/Nassau": "America/Nassau",
    "timeZone.America/New_York": "America/New_York",
    "timeZone.America/Nipigon": "America/Nipigon",
    "timeZone.America/Nome": "America/Nome",
    "timeZone.America/Noronha": "America/Noronha",
    "timeZone.America/North_Dakota/Beulah": "America/North_Dakota/Beulah",
    "timeZone.America/North_Dakota/Center": "America/North_Dakota/Center",
    "timeZone.America/North_Dakota/New_Salem": "America/North_Dakota/New_Salem",
    "timeZone.America/Nuuk": "America/Nuuk",
    "timeZone.America/Ojinaga": "America/Ojinaga",
    "timeZone.America/Panama": "America/Panama",
    "timeZone.America/Pangnirtung": "America/Pangnirtung",
    "timeZone.America/Paramaribo": "America/Paramaribo",
    "timeZone.America/Phoenix": "America/Phoenix",
    "timeZone.America/Port_of_Spain": "America/Port_of_Spain",
    "timeZone.America/Port-au-Prince": "America/Port-au-Prince",
    "timeZone.America/Porto_Velho": "America/Porto_Velho",
    "timeZone.America/Puerto_Rico": "America/Puerto_Rico",
    "timeZone.America/Punta_Arenas": "America/Punta_Arenas",
    "timeZone.America/Rainy_River": "America/Rainy_River",
    "timeZone.America/Rankin_Inlet": "America/Rankin_Inlet",
    "timeZone.America/Recife": "America/Recife",
    "timeZone.America/Regina": "America/Regina",
    "timeZone.America/Resolute": "America/Resolute",
    "timeZone.America/Rio_Branco": "America/Rio_Branco",
    "timeZone.America/Santa_Isabel": "America/Santa_Isabel",
    "timeZone.America/Santarem": "America/Santarem",
    "timeZone.America/Santiago": "America/Santiago",
    "timeZone.America/Santo_Domingo": "America/Santo_Domingo",
    "timeZone.America/Sao_Paulo": "America/Sao_Paulo",
    "timeZone.America/Scoresbysund": "America/Scoresbysund",
    "timeZone.America/Sitka": "America/Sitka",
    "timeZone.America/St_Barthelemy": "America/St_Barthelemy",
    "timeZone.America/St_Johns": "America/St_Johns",
    "timeZone.America/St_Kitts": "America/St_Kitts",
    "timeZone.America/St_Lucia": "America/St_Lucia",
    "timeZone.America/St_Thomas": "America/St_Thomas",
    "timeZone.America/St_Vincent": "America/St_Vincent",
    "timeZone.America/Swift_Current": "America/Swift_Current",
    "timeZone.America/Tegucigalpa": "America/Tegucigalpa",
    "timeZone.America/Thule": "America/Thule",
    "timeZone.America/Thunder_Bay": "America/Thunder_Bay",
    "timeZone.America/Tijuana": "America/Tijuana",
    "timeZone.America/Toronto": "America/Toronto",
    "timeZone.America/Tortola": "America/Tortola",
    "timeZone.America/Vancouver": "America/Vancouver",
    "timeZone.America/Whitehorse": "America/Whitehorse",
    "timeZone.America/Winnipeg": "America/Winnipeg",
    "timeZone.America/Yakutat": "America/Yakutat",
    "timeZone.America/Yellowknife": "America/Yellowknife",
    "timeZone.Antarctica/Casey": "Antarctica/Casey",
    "timeZone.Antarctica/Davis": "Antarctica/Davis",
    "timeZone.Antarctica/DumontDUrville": "Antarctica/DumontDUrville",
    "timeZone.Antarctica/Macquarie": "Antarctica/Macquarie",
    "timeZone.Antarctica/Mawson": "Antarctica/Mawson",
    "timeZone.Antarctica/McMurdo": "Antarctica/McMurdo",
    "timeZone.Antarctica/Palmer": "Antarctica/Palmer",
    "timeZone.Antarctica/Rothera": "Antarctica/Rothera",
    "timeZone.Antarctica/Syowa": "Antarctica/Syowa",
    "timeZone.Antarctica/Troll": "Antarctica/Troll",
    "timeZone.Antarctica/Vostok": "Antarctica/Vostok",
    "timeZone.Arctic/Longyearbyen": "Arctic/Longyearbyen",
    "timeZone.Asia/Aden": "Asia/Aden",
    "timeZone.Asia/Almaty": "Asia/Almaty",
    "timeZone.Asia/Amman": "Asia/Amman",
    "timeZone.Asia/Anadyr": "Asia/Anadyr",
    "timeZone.Asia/Aqtau": "Asia/Aqtau",
    "timeZone.Asia/Aqtobe": "Asia/Aqtobe",
    "timeZone.Asia/Ashgabat": "Asia/Ashgabat",
    "timeZone.Asia/Atyrau": "Asia/Atyrau",
    "timeZone.Asia/Baghdad": "Asia/Baghdad",
    "timeZone.Asia/Bahrain": "Asia/Bahrain",
    "timeZone.Asia/Baku": "Asia/Baku",
    "timeZone.Asia/Bangkok": "Asia/Bangkok",
    "timeZone.Asia/Barnaul": "Asia/Barnaul",
    "timeZone.Asia/Beirut": "Asia/Beirut",
    "timeZone.Asia/Bishkek": "Asia/Bishkek",
    "timeZone.Asia/Brunei": "Asia/Brunei",
    "timeZone.Asia/Calcutta": "Asia/Calcutta",
    "timeZone.Asia/Chita": "Asia/Chita",
    "timeZone.Asia/Choibalsan": "Asia/Choibalsan",
    "timeZone.Asia/Chongqing": "Asia/Chongqing",
    "timeZone.Asia/Colombo": "Asia/Colombo",
    "timeZone.Asia/Damascus": "Asia/Damascus",
    "timeZone.Asia/Dhaka": "Asia/Dhaka",
    "timeZone.Asia/Dili": "Asia/Dili",
    "timeZone.Asia/Dubai": "Asia/Dubai",
    "timeZone.Asia/Dushanbe": "Asia/Dushanbe",
    "timeZone.Asia/Famagusta": "Asia/Famagusta",
    "timeZone.Asia/Gaza": "Asia/Gaza",
    "timeZone.Asia/Harbin": "Asia/Harbin",
    "timeZone.Asia/Hebron": "Asia/Hebron",
    "timeZone.Asia/Ho_Chi_Minh": "Asia/Ho_Chi_Minh",
    "timeZone.Asia/Hong_Kong": "Asia/Hong_Kong",
    "timeZone.Asia/Hovd": "Asia/Hovd",
    "timeZone.Asia/Irkutsk": "Asia/Irkutsk",
    "timeZone.Asia/Istanbul": "Asia/Istanbul",
    "timeZone.Asia/Jakarta": "Asia/Jakarta",
    "timeZone.Asia/Jayapura": "Asia/Jayapura",
    "timeZone.Asia/Jerusalem": "Asia/Jerusalem",
    "timeZone.Asia/Kabul": "Asia/Kabul",
    "timeZone.Asia/Kamchatka": "Asia/Kamchatka",
    "timeZone.Asia/Karachi": "Asia/Karachi",
    "timeZone.Asia/Kashgar": "Asia/Kashgar",
    "timeZone.Asia/Kathmandu": "Asia/Kathmandu",
    "timeZone.Asia/Katmandu": "Asia/Katmandu",
    "timeZone.Asia/Khandyga": "Asia/Khandyga",
    "timeZone.Asia/Kolkata": "Asia/Kolkata",
    "timeZone.Asia/Krasnoyarsk": "Asia/Krasnoyarsk",
    "timeZone.Asia/Kuala_Lumpur": "Asia/Kuala_Lumpur",
    "timeZone.Asia/Kuching": "Asia/Kuching",
    "timeZone.Asia/Kuwait": "Asia/Kuwait",
    "timeZone.Asia/Macau": "Asia/Macau",
    "timeZone.Asia/Magadan": "Asia/Magadan",
    "timeZone.Asia/Makassar": "Asia/Makassar",
    "timeZone.Asia/Manila": "Asia/Manila",
    "timeZone.Asia/Muscat": "Asia/Muscat",
    "timeZone.Asia/Nicosia": "Asia/Nicosia",
    "timeZone.Asia/Novokuznetsk": "Asia/Novokuznetsk",
    "timeZone.Asia/Novosibirsk": "Asia/Novosibirsk",
    "timeZone.Asia/Omsk": "Asia/Omsk",
    "timeZone.Asia/Oral": "Asia/Oral",
    "timeZone.Asia/Phnom_Penh": "Asia/Phnom_Penh",
    "timeZone.Asia/Pontianak": "Asia/Pontianak",
    "timeZone.Asia/Pyongyang": "Asia/Pyongyang",
    "timeZone.Asia/Qatar": "Asia/Qatar",
    "timeZone.Asia/Qostanay": "Asia/Qostanay",
    "timeZone.Asia/Qyzylorda": "Asia/Qyzylorda",
    "timeZone.Asia/Rangoon": "Asia/Rangoon",
    "timeZone.Asia/Riyadh": "Asia/Riyadh",
    "timeZone.Asia/Sakhalin": "Asia/Sakhalin",
    "timeZone.Asia/Samarkand": "Asia/Samarkand",
    "timeZone.Asia/Seoul": "Asia/Seoul",
    "timeZone.Asia/Shanghai": "Asia/Shanghai",
    "timeZone.Asia/Singapore": "Asia/Singapore",
    "timeZone.Asia/Srednekolymsk": "Asia/Srednekolymsk",
    "timeZone.Asia/Taipei": "Asia/Taipei",
    "timeZone.Asia/Tashkent": "Asia/Tashkent",
    "timeZone.Asia/Tbilisi": "Asia/Tbilisi",
    "timeZone.Asia/Tehran": "Asia/Tehran",
    "timeZone.Asia/Thimphu": "Asia/Thimphu",
    "timeZone.Asia/Tokyo": "Asia/Tokyo",
    "timeZone.Asia/Tomsk": "Asia/Tomsk",
    "timeZone.Asia/Ulaanbaatar": "Asia/Ulaanbaatar",
    "timeZone.Asia/Urumqi": "Asia/Urumqi",
    "timeZone.Asia/Ust-Nera": "Asia/Ust-Nera",
    "timeZone.Asia/Vientiane": "Asia/Vientiane",
    "timeZone.Asia/Vladivostok": "Asia/Vladivostok",
    "timeZone.Asia/Yakutsk": "Asia/Yakutsk",
    "timeZone.Asia/Yangon": "Asia/Yangon",
    "timeZone.Asia/Yekaterinburg": "Asia/Yekaterinburg",
    "timeZone.Asia/Yerevan": "Asia/Yerevan",
    "timeZone.Atlantic/Azores": "Atlantic/Azores",
    "timeZone.Atlantic/Bermuda": "Atlantic/Bermuda",
    "timeZone.Atlantic/Canary": "Atlantic/Canary",
    "timeZone.Atlantic/Cape_Verde": "Atlantic/Cape_Verde",
    "timeZone.Atlantic/Faroe": "Atlantic/Faroe",
    "timeZone.Atlantic/Madeira": "Atlantic/Madeira",
    "timeZone.Atlantic/Reykjavik": "Atlantic/Reykjavik",
    "timeZone.Atlantic/South_Georgia": "Atlantic/South_Georgia",
    "timeZone.Atlantic/St_Helena": "Atlantic/St_Helena",
    "timeZone.Atlantic/Stanley": "Atlantic/Stanley",
    "timeZone.Australia/Adelaide": "Australia/Adelaide",
    "timeZone.Australia/Brisbane": "Australia/Brisbane",
    "timeZone.Australia/Broken_Hill": "Australia/Broken_Hill",
    "timeZone.Australia/Currie": "Australia/Currie",
    "timeZone.Australia/Darwin": "Australia/Darwin",
    "timeZone.Australia/Eucla": "Australia/Eucla",
    "timeZone.Australia/Hobart": "Australia/Hobart",
    "timeZone.Australia/Lindeman": "Australia/Lindeman",
    "timeZone.Australia/Lord_Howe": "Australia/Lord_Howe",
    "timeZone.Australia/Melbourne": "Australia/Melbourne",
    "timeZone.Australia/Perth": "Australia/Perth",
    "timeZone.Australia/Sydney": "Australia/Sydney",
    "timeZone.CET": "CET",
    "timeZone.CST6CDT": "CST6CDT",
    "timeZone.EET": "EET",
    "timeZone.EST": "EST",
    "timeZone.EST5EDT": "EST5EDT",
    "timeZone.Etc/GMT-1": "Etc/GMT-1",
    "timeZone.Etc/GMT-10": "Etc/GMT-10",
    "timeZone.Etc/GMT-11": "Etc/GMT-11",
    "timeZone.Etc/GMT-12": "Etc/GMT-12",
    "timeZone.Etc/GMT-13": "Etc/GMT-13",
    "timeZone.Etc/GMT-14": "Etc/GMT-14",
    "timeZone.Etc/GMT-2": "Etc/GMT-2",
    "timeZone.Etc/GMT-3": "Etc/GMT-3",
    "timeZone.Etc/GMT-4": "Etc/GMT-4",
    "timeZone.Etc/GMT-5": "Etc/GMT-5",
    "timeZone.Etc/GMT-6": "Etc/GMT-6",
    "timeZone.Etc/GMT-7": "Etc/GMT-7",
    "timeZone.Etc/GMT-8": "Etc/GMT-8",
    "timeZone.Etc/GMT-9": "Etc/GMT-9",
    "timeZone.Etc/GMT": "Etc/GMT",
    "timeZone.Etc/GMT+1": "Etc/GMT+1",
    "timeZone.Etc/GMT+10": "Etc/GMT+10",
    "timeZone.Etc/GMT+11": "Etc/GMT+11",
    "timeZone.Etc/GMT+12": "Etc/GMT+12",
    "timeZone.Etc/GMT+2": "Etc/GMT+2",
    "timeZone.Etc/GMT+3": "Etc/GMT+3",
    "timeZone.Etc/GMT+4": "Etc/GMT+4",
    "timeZone.Etc/GMT+5": "Etc/GMT+5",
    "timeZone.Etc/GMT+6": "Etc/GMT+6",
    "timeZone.Etc/GMT+7": "Etc/GMT+7",
    "timeZone.Etc/GMT+8": "Etc/GMT+8",
    "timeZone.Etc/GMT+9": "Etc/GMT+9",
    "timeZone.Etc/UCT": "Etc/UCT",
    "timeZone.Etc/UTC": "Etc/UTC",
    "timeZone.Europe/Amsterdam": "Europe/Amsterdam",
    "timeZone.Europe/Andorra": "Europe/Andorra",
    "timeZone.Europe/Astrakhan": "Europe/Astrakhan",
    "timeZone.Europe/Athens": "Europe/Athens",
    "timeZone.Europe/Belgrade": "Europe/Belgrade",
    "timeZone.Europe/Berlin": "Europe/Berlin",
    "timeZone.Europe/Bratislava": "Europe/Bratislava",
    "timeZone.Europe/Brussels": "Europe/Brussels",
    "timeZone.Europe/Busingen": "Europe/Busingen",
    "timeZone.Europe/Bucharest": "Europe/Bucharest",
    "timeZone.Europe/Budapest": "Europe/Budapest",
    "timeZone.Europe/Chisinau": "Europe/Chisinau",
    "timeZone.Europe/Copenhagen": "Europe/Copenhagen",
    "timeZone.Europe/Dublin": "Europe/Dublin",
    "timeZone.Europe/Gibraltar": "Europe/Gibraltar",
    "timeZone.Europe/Guernsey": "Europe/Guernsey",
    "timeZone.Europe/Helsinki": "Europe/Helsinki",
    "timeZone.Europe/Isle_of_Man": "Europe/Isle_of_Man",
    "timeZone.Europe/Istanbul": "Europe/Istanbul",
    "timeZone.Europe/Jersey": "Europe/Jersey",
    "timeZone.Europe/Kaliningrad": "Europe/Kaliningrad",
    "timeZone.Europe/Kiev": "Europe/Kiev",
    "timeZone.Europe/Kirov": "Europe/Kirov",
    "timeZone.Europe/Kyiv": "Europe/Kyiv",
    "timeZone.Europe/Lisbon": "Europe/Lisbon",
    "timeZone.Europe/Ljubljana": "Europe/Ljubljana",
    "timeZone.Europe/London": "Europe/London",
    "timeZone.Europe/Luxembourg": "Europe/Luxembourg",
    "timeZone.Europe/Madrid": "Europe/Madrid",
    "timeZone.Europe/Malta": "Europe/Malta",
    "timeZone.Europe/Mariehamn": "Europe/Mariehamn",
    "timeZone.Europe/Minsk": "Europe/Minsk",
    "timeZone.Europe/Monaco": "Europe/Monaco",
    "timeZone.Europe/Moscow": "Europe/Moscow",
    "timeZone.Europe/Nicosia": "Europe/Nicosia",
    "timeZone.Europe/Oslo": "Europe/Oslo",
    "timeZone.Europe/Paris": "Europe/Paris",
    "timeZone.Europe/Podgorica": "Europe/Podgorica",
    "timeZone.Europe/Prague": "Europe/Prague",
    "timeZone.Europe/Riga": "Europe/Riga",
    "timeZone.Europe/Rome": "Europe/Rome",
    "timeZone.Europe/Samara": "Europe/Samara",
    "timeZone.Europe/San_Marino": "Europe/San_Marino",
    "timeZone.Europe/Sarajevo": "Europe/Sarajevo",
    "timeZone.Europe/Saratov": "Europe/Saratov",
    "timeZone.Europe/Simferopol": "Europe/Simferopol",
    "timeZone.Europe/Skopje": "Europe/Skopje",
    "timeZone.Europe/Sofia": "Europe/Sofia",
    "timeZone.Europe/Stockholm": "Europe/Stockholm",
    "timeZone.Europe/Tallinn": "Europe/Tallinn",
    "timeZone.Europe/Tirane": "Europe/Tirane",
    "timeZone.Europe/Ulyanovsk": "Europe/Ulyanovsk",
    "timeZone.Europe/Uzhgorod": "Europe/Uzhgorod",
    "timeZone.Europe/Vaduz": "Europe/Vaduz",
    "timeZone.Europe/Vatican": "Europe/Vatican",
    "timeZone.Europe/Vienna": "Europe/Vienna",
    "timeZone.Europe/Vilnius": "Europe/Vilnius",
    "timeZone.Europe/Volgograd": "Europe/Volgograd",
    "timeZone.Europe/Warsaw": "Europe/Warsaw",
    "timeZone.Europe/Zagreb": "Europe/Zagreb",
    "timeZone.Europe/Zaporozhye": "Europe/Zaporozhye",
    "timeZone.Europe/Zurich": "Europe/Zurich",
    "timeZone.GMT-12:00": "GMT-12:00",
    "timeZone.GMT": "GMT",
    "timeZone.HST": "HST",
    "timeZone.Indian/Antananarivo": "Indian/Antananarivo",
    "timeZone.Indian/Chagos": "Indian/Chagos",
    "timeZone.Indian/Christmas": "Indian/Christmas",
    "timeZone.Indian/Cocos": "Indian/Cocos",
    "timeZone.Indian/Comoro": "Indian/Comoro",
    "timeZone.Indian/Kerguelen": "Indian/Kerguelen",
    "timeZone.Indian/Mahe": "Indian/Mahe",
    "timeZone.Indian/Maldives": "Indian/Maldives",
    "timeZone.Indian/Mauritius": "Indian/Mauritius",
    "timeZone.Indian/Mayotte": "Indian/Mayotte",
    "timeZone.Indian/Reunion": "Indian/Reunion",
    "timeZone.MET": "MET",
    "timeZone.MST": "MST",
    "timeZone.MST7MDT": "MST7MDT",
    "timeZone.Pacific/Apia": "Pacific/Apia",
    "timeZone.Pacific/Auckland": "Pacific/Auckland",
    "timeZone.Pacific/Bougainville": "Pacific/Bougainville",
    "timeZone.Pacific/Chatham": "Pacific/Chatham",
    "timeZone.Pacific/Chuuk": "Pacific/Chuuk",
    "timeZone.Pacific/Easter": "Pacific/Easter",
    "timeZone.Pacific/Efate": "Pacific/Efate",
    "timeZone.Pacific/Enderbury": "Pacific/Enderbury",
    "timeZone.Pacific/Fakaofo": "Pacific/Fakaofo",
    "timeZone.Pacific/Fiji": "Pacific/Fiji",
    "timeZone.Pacific/Funafuti": "Pacific/Funafuti",
    "timeZone.Pacific/Galapagos": "Pacific/Galapagos",
    "timeZone.Pacific/Gambier": "Pacific/Gambier",
    "timeZone.Pacific/Guadalcanal": "Pacific/Guadalcanal",
    "timeZone.Pacific/Guam": "Pacific/Guam",
    "timeZone.Pacific/Honolulu": "Pacific/Honolulu",
    "timeZone.Pacific/Johnston": "Pacific/Johnston",
    "timeZone.Pacific/Kanton": "Pacific/Kanton",
    "timeZone.Pacific/Kiritimati": "Pacific/Kiritimati",
    "timeZone.Pacific/Kosrae": "Pacific/Kosrae",
    "timeZone.Pacific/Kwajalein": "Pacific/Kwajalein",
    "timeZone.Pacific/Majuro": "Pacific/Majuro",
    "timeZone.Pacific/Marquesas": "Pacific/Marquesas",
    "timeZone.Pacific/Midway": "Pacific/Midway",
    "timeZone.Pacific/Nauru": "Pacific/Nauru",
    "timeZone.Pacific/Niue": "Pacific/Niue",
    "timeZone.Pacific/Norfolk": "Pacific/Norfolk",
    "timeZone.Pacific/Noumea": "Pacific/Noumea",
    "timeZone.Pacific/Pago_Pago": "Pacific/Pago_Pago",
    "timeZone.Pacific/Palau": "Pacific/Palau",
    "timeZone.Pacific/Pitcairn": "Pacific/Pitcairn",
    "timeZone.Pacific/Pohnpei": "Pacific/Pohnpei",
    "timeZone.Pacific/Port_Moresby": "Pacific/Port_Moresby",
    "timeZone.Pacific/Rarotonga": "Pacific/Rarotonga",
    "timeZone.Pacific/Saipan": "Pacific/Saipan",
    "timeZone.Pacific/Tahiti": "Pacific/Tahiti",
    "timeZone.Pacific/Tarawa": "Pacific/Tarawa",
    "timeZone.Pacific/Tongatapu": "Pacific/Tongatapu",
    "timeZone.Pacific/Wake": "Pacific/Wake",
    "timeZone.Pacific/Wallis": "Pacific/Wallis",
    "timeZone.PST8PDT": "PST8PDT",
    "timeZone.UTC": "UTC",
    "timeZone.WET": "WET",

    "locales.sq_AL": "Albanian - Albania",
    "locales.ar_DZ": "Arabic - Algeria",
    "locales.ar_BH": "Arabic - Bahrain",
    "locales.ar_EG": "Arabic - Egypt",
    "locales.ar_IQ": "Arabic - Iraq",
    "locales.ar_JO": "Arabic - Jordan",
    "locales.ar_KW": "Arabic - Kuwait",
    "locales.ar_LB": "Arabic - Lebanon",
    "locales.ar_LY": "Arabic - Libya",
    "locales.ar_MA": "Arabic - Morocco",
    "locales.ar_OM": "Arabic - Oman",
    "locales.ar_QA": "Arabic - Qatar",
    "locales.ar_SA": "Arabic - Saudi Arabia",
    "locales.ar_SD": "Arabic - Sudan",
    "locales.ar_SY": "Arabic - Syria",
    "locales.ar_TN": "Arabic - Tunisia",
    "locales.ar_AE": "Arabic - United Arab Emirates",
    "locales.ar_YE": "Arabic - Yemen",
    "locales.be_BY": "Belarusian - Belarus",
    "locales.bg_BG": "Bulgarian - Bulgaria",
    "locales.ca_ES": "Catalan - Spain",
    "locales.zh_CN": "Chinese (Simplified) - China",
    "locales.zh_SG": "Chinese (Simplified) - Singapore",
    "locales.zh_HK": "Chinese (Traditional) - Hong Kong",
    "locales.zh_TW": "Chinese (Traditional) - Taiwan",
    "locales.hr_HR": "Croatian - Croatia",
    "locales.cs_CZ": "Czech - Czech Republic",
    "locales.da_DK": "Danish - Denmark",
    "locales.nl_BE": "Dutch - Belgium",
    "locales.nl_NL": "Dutch - Netherlands",
    "locales.en_AU": "English - Australia",
    "locales.en_CA": "English - Canada",
    "locales.en_IN": "English - India",
    "locales.en_IE": "English - Ireland",
    "locales.en_MT": "English - Malta",
    "locales.en_NZ": "English - New Zealand",
    "locales.en_PH": "English - Philippines",
    "locales.en_SG": "English - Singapore",
    "locales.en_ZA": "English - South Africa",
    "locales.en_GB": "English - United Kingdom",
    "locales.en_US": "English - United States",
    "locales.et_EE": "Estonian - Estonia",
    "locales.fi_FI": "Finnish - Finland",
    "locales.fr_BE": "French - Belgium",
    "locales.fr_CA": "French - Canada",
    "locales.fr_FR": "French - France",
    "locales.fr_LU": "French - Luxembourg",
    "locales.fr_CH": "French - Switzerland",
    "locales.de_AT": "German - Austria",
    "locales.de_DE": "German - Germany",
    "locales.de_LU": "German - Luxembourg",
    "locales.de_CH": "German - Switzerland",
    "locales.el_CY": "Greek - Cyprus",
    "locales.el_GR": "Greek - Greece",
    "locales.iw_IL": "Hebrew - Israel",
    "locales.hi_IN": "Hindi - India",
    "locales.hu_HU": "Hungarian - Hungary",
    "locales.is_IS": "Icelandic - Iceland",
    "locales.in_ID": "Indonesian - Indonesia",
    "locales.ga_IE": "Irish - Ireland",
    "locales.it_IT": "Italian - Italy",
    "locales.it_CH": "Italian - Switzerland",
    "locales.ja_JP": "Japanese (Gregorian calendar) - Japan",
    "locales.ja_JP_JP": "Japanese (Imperial calendar) - Japan",
    "locales.ko_KR": "Korean - South Korea",
    "locales.lv_LV": "Latvian - Latvia",
    "locales.lt_LT": "Lithuanian - Lithuania",
    "locales.mk_MK": "Macedonian - Macedonia",
    "locales.ms_MY": "Malay - Malaysia",
    "locales.mt_MT": "Maltese - Malta",
    "locales.no_NO": "Norwegian (Bokmål) - Norway",
    "locales.no_NO_NY": "Norwegian (Nynorsk) - Norway",
    "locales.pl_PL": "Polish - Poland",
    "locales.pt_BR": "Portuguese - Brazil",
    "locales.pt_PT": "Portuguese - Portugal",
    "locales.ro_RO": "Romanian - Romania",
    "locales.ru_RU": "Russian - Russia",
    "locales.sr_BA": "Serbian (Cyrillic) - Bosnia and Herzegovina",
    "locales.sr_ME": "Serbian (Cyrillic) - Montenegro",
    "locales.sr_RS": "Serbian (Cyrillic) - Serbia",
    "locales.sr_Latn_BA": "Serbian (Latin) - Bosnia and Herzegovina",
    "locales.sr_Latn_ME": "Serbian (Latin) - Montenegro",
    "locales.sr_Latn_RS": "Serbian (Latin) - Serbia",
    "locales.sk_SK": "Slovak - Slovakia",
    "locales.sl_SI": "Slovenian - Slovenia",
    "locales.es_AR": "Spanish - Argentina",
    "locales.es_BO": "Spanish - Bolivia",
    "locales.es_CL": "Spanish - Chile",
    "locales.es_CO": "Spanish - Colombia",
    "locales.es_CR": "Spanish - Costa Rica",
    "locales.es_DO": "Spanish - Dominican Republic",
    "locales.es_EC": "Spanish - Ecuador",
    "locales.es_SV": "Spanish - El Salvador",
    "locales.es_GT": "Spanish - Guatemala",
    "locales.es_HN": "Spanish - Honduras",
    "locales.es_MX": "Spanish - Mexico",
    "locales.es_NI": "Spanish - Nicaragua",
    "locales.es_PA": "Spanish - Panama",
    "locales.es_PY": "Spanish - Paraguay",
    "locales.es_PE": "Spanish - Peru",
    "locales.es_PR": "Spanish - Puerto Rico",
    "locales.es_ES": "Spanish - Spain",
    "locales.es_US": "Spanish - United States",
    "locales.es_UY": "Spanish - Uruguay",
    "locales.es_VE": "Spanish - Venezuela",
    "locales.sv_SE": "Swedish - Sweden",
    "locales.th_TH": "Thai (Western digits) - Thailand",
    "locales.th_TH_TH": "Thai (Thai digits) - Thailand",
    "locales.tr_TR": "Turkish - Turkey",
    "locales.uk_UA": "Ukrainian - Ukraine",
    "locales.vi_VN": "Vietnamese - Vietnam",

    "locales.ar": "Arabic",
    "locales.be": "Belarusian",
    "locales.bg": "Bulgarian",
    "locales.ca": "Catalan",
    "locales.cs": "Czech",
    "locales.da": "Danish",
    "locales.de": "German",
    "locales.el": "Greek",
    "locales.en": "English",
    "locales.es": "Spanish",
    "locales.fr": "French",
    "locales.ga": "Irish",
    "locales.hi": "Hindi",
    "locales.hr": "Croatian",
    "locales.hu": "Hungarian",
    "locales.in": "Indonesian",
    "locales.is": "Icelandic",
    "locales.it": "Italian",
    "locales.iw": "Hebrew",
    "locales.ja": "Japanese",
    "locales.ko": "Korean",
    "locales.lv": "Latvian",
    "locales.lt": "Lithuanian",
    "locales.mk": "Macedonian",
    "locales.ms": "Malay",
    "locales.mt": "Maltese",
    "locales.no": "Norwegian",
    "locales.nl": "Dutch",
    "locales.pl": "Polish",
    "locales.pt": "Portuguese",
    "locales.ro": "Romanian",
    "locales.ru": "Russian",
    "locales.sk": "Slovak",
    "locales.sl": "Slovenian",
    "locales.sq": "Albanian",
    "locales.sr": "Serbian",
    "locales.sv": "Swedish",
    "locales.tr": "Turkish",
    "locales.th": "Thai",
    "locales.uk": "Ukrainian",
    "locales.vi": "Vietnamese",
    "locales.zh": "Chinese",

    "units.days": "Days",
    "units.bytes": "Bytes",
    "units.megabytes": "MB",
    "units.kilobytes": "KB",
    "units.gigabytes": "GB",
    "units.terabytes": "TB",
    "units.seconds": "Seconds",

    "formats.size":  "{{size}} {{units}}",

    "sortablePanels.cancel": "Cancel",
    "sortablePanels.previous": "Previous",
    "sortablePanels.next": "Next",
    "sortablePanels.noData": "There are no panels",
    "sortablePanels.movePanelUp": "Move panel up.",
    "sortablePanels.movePanelDown": "Move panel down.",
    "sortablePanels.removePanel": "Remove panel.",
    "sortablePanels.undoRemovePanel": "Undo removing this panel.",
    "sortablePanels.openPanel": "Open panel.",
    "sortablePanels.closePanel": "Close panel.",

    "listEditor.addNewItem": "Add new item",

    "calendar.eventTimeRange": "{{ startTime }} - {{ endTime }}",

    "interaction.list.delimiter": ", ",
    "widget.clearInput.screenreader": "Clear input",

    "widget.timeinput.placeholder": "--",
    "widget.timeinput.short.placeholder": "-",
    "widget.timeinput.delimiter": ":",
    "widget.timeinput.placeholder.am": "AM",
    "widget.timeinput.am": "AM",
    "widget.timeinput.pm": "PM",
    "widget.timeinput.selected.hours": "Hours",
    "widget.timeinput.selected.minutes": "Minutes",
    "widget.timeinput.selected.seconds": "Seconds",
    "widget.timeinput.selected.ampm": "AM or PM selection",
    "widget.timeinput.selected.increase": "Increase the {{currentSelection}}",
    "widget.timeinput.selected.decrease": "Decrease the {{currentSelection}}",
    "widget.timeinput.selected.clear": "Clear the time input",


    "widget.combobox.placeholder.multi": "Type or Select Item(s)",
    "widget.combobox.placeholder.single": "Type or Select Item",
    "widget.combobox.searching": "Searching...",
    "widget.combobox.noMatches": "No matches",
    "widget.combobox.removeSelection": "Remove selection",

    "widget.dateRangePicker.intervalFormat": "{{startDate}} - {{endDate}}",
    "widget.dateRangePicker.invalidInterval": "Invalid interval",
    "widget.dateRangePicker.error": "There was an error creating DateRangePicker2: ",
    "widget.datePicker.format": "{{date}}",

    "widget.inheritedFormControl.details": "Property Details",
    "widget.inheritedFormControl.tooltip.overridden": "This value has been overridden and is not inheriting from the base settings.",
    "widget.inheritedFormControl.tooltip.inherited": "This value has been inherited from the base settings and will update when the base settings change.",
    "widget.inheritedFormControl.tooltip.inheritedValue": "Base settings value: {{inheritedDisplayValue}}",
    "widget.inheritedFormControl.tooltip.reset": "Inherit this Setting",
    "widget.inheritedFormControl.tooltip.override": "Override this Setting",
    "widget.inheritedFormControl.tooltip.true": "Enabled",
    "widget.inheritedFormControl.tooltip.false": "Disabled",
    "widget.inheritedFormControl.tooltip.empty": "Empty value",

    "widget.inheritedFormControl.tooltip.default.value": "Default value: {{inheritedDisplayValue}}",
    "widget.inheritedFormControl.tooltip.default.reset": "Set to Default",

    "dataGrid.copyLabel": "{{name}} - copy",

    "interactions.audit.timestamp": "Date",
    "interactions.audit.action": "Action",
    "interactions.audit.level": "Level",
    "interactions.audit.status": "Status",
    "interactions.audit.entityType": "Entity Type",
    "interactions.audit.user": "User",
    "interactions.audit.status.SUCCESS": "Success",
    "interactions.audit.status.FAILED": "Failed",
    "interactions.audit.level.USER": "User",
    "interactions.audit.level.SYSTEM": "System",
    "interactions.audit.entityType.RECORDING": "Recording",
    "interactions.audit.entityType.ANNOTATION": "Annotation",
    "interactions.audit.entityType.CALIBRATION": "Calibration",
    "interactions.audit.entityType.EVALUATION": "Evaluation",
    "interactions.audit.entityType.SCREEN-RECORDING": "Screen Recording",
    "interactions.audit.actions.CREATE": "Create",
    "interactions.audit.actions.UPDATE": "Update",
    "interactions.audit.actions.READ": "Read",
    "interactions.audit.actions.DELETE": "Delete",
    "interactions.audit.actions.ARCHIVE": "Archive",
    "interactions.audit.actions.EXPORT": "Export",
    "interactions.audit.actions.RESTORE-REQUEST": "Restore Request",
    "interactions.audit.actions.RESTORE-COMPLETE": "Restore Complete",
    "interactions.audit.actions.UPDATE-RETENTION": "Retention Update",
    "interactions.audit.actions.APPLY-PROTECTION": "Apply Protection",
    "interactions.audit.actions.REVOKE-PROTECTION": "Revoke Protection",

    "property.reference.error.default":"The list of valid references for {{propertyName}} is empty. This is probably a setup error.",

    "customListEditor.add.error": "Unable to create a new item entry.",
    "customListEditor.update.error": "Unable to save specified entry.",
    "customListEditor.remove.error": "Unable to remove specified entry.",
    "customListEditor.emptyPlaceholder": "Add an item below",
    "customListEditor.save": "Save",

    "dataGridCells.enumFilter.all": "All",

    "timeRange.picker.select.timeRange": "Select Time Range",
    "timeRange.picker.reset.default": "Restore to Defaults",
    "timeRange.picker.select.invalid.format":"Time format is not valid.",
    "timeRange.picker.startTime": "Start Time",
    "timeRange.picker.startHour": "Starting Hour",
    "timeRange.picker.startMinute": "Starting Minutes",
    "timeRange.picker.startAMPM": "Starting AM or PM",

    "timeRange.picker.endTime": "End Time",
    "timeRange.picker.endHour": "Ending Hour",
    "timeRange.picker.endMinute": "Ending Minutes",
    "timeRange.picker.endAMPM": "Ending AM or PM",
    "timeRange.picker.timeSeparator" : ":",
    "timeRange.picker.timeApply": "Apply",
    "timeRange.picker.timeFormat": "LT",

    "quality.forms.lists.nextPage": "Next Page",
    "quality.forms.lists.previousPage": "Previous Page",
    "quality.forms.lists.pageNumber": "Page Number"
}
;});

